import * as i2 from '@angular/common';
import { DOCUMENT, CommonModule, DatePipe } from '@angular/common';
import * as i0 from '@angular/core';
import { Component, ViewChild, Directive, Inject, Input, NgModule, ContentChild, EventEmitter, Output, HostListener, ContentChildren, forwardRef, Injectable, Pipe, ElementRef, ViewChildren, TemplateRef, ChangeDetectionStrategy, LOCALE_ID, Optional, Injector, SkipSelf } from '@angular/core';
import * as i1 from '@ng-bootstrap/ng-bootstrap';
import { NgbPaginationPages, NgbTooltipModule, NgbDropdownMenu, NgbDropdownToggle, NgbDropdownModule, NgbNavModule, NgbModule, NgbDropdown, NgbPopoverModule, NgbToastModule, NgbDatepicker, NgbDatepickerModule, NgbTimepicker, NgbTimepickerModule } from '@ng-bootstrap/ng-bootstrap';
import * as i2$1 from '@angular/cdk/a11y';
import { A11yModule, ConfigurableFocusTrapFactory } from '@angular/cdk/a11y';
import { Subject, takeUntil, timer, fromEvent, filter, Subscription, startWith, tap, take, noop, BehaviorSubject, map, interval } from 'rxjs';
import * as i3 from '@angular/forms';
import { NG_VALUE_ACCESSOR, FormsModule, FormControl, Validators, NgControl, ReactiveFormsModule, FormGroup, FormControlName, FormControlDirective } from '@angular/forms';
import { v4 } from 'uuid';

const OPT_OUT_SELECTOR = ':not([ngbDefault])';

class NgbA11yPaginationPagesDynamicComponent {
}
NgbA11yPaginationPagesDynamicComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: NgbA11yPaginationPagesDynamicComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
NgbA11yPaginationPagesDynamicComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: NgbA11yPaginationPagesDynamicComponent, selector: "lh-dynamic-pagination-pages", viewQueries: [{ propertyName: "tplPages", first: true, predicate: ["defaultPages"], descendants: true }], ngImport: i0, template: "<ng-template #prevTooltipTpl>Previous Page</ng-template>\n<ng-template #nextTooltipTpl>Next Page</ng-template>\n\n<ng-template #previous><span aria-hidden=\"true\">&laquo;</span></ng-template>\n<ng-template #next><span aria-hidden=\"true\">&raquo;</span></ng-template>\n\n<ng-template #defaultNumber let-page let-currentPage=\"currentPage\">\n  <span class=\"visually-hidden\">page </span>\n  {{ page }}\n</ng-template>\n\n<ng-template #ellipsis>...</ng-template>\n\n<ng-template #defaultPages let-page let-pages=\"pages\" let-disabled=\"disabled\">\n  <li class=\"page-item\" [class.disabled]=\"ngbPagination.previousDisabled()\">\n    <a\n      [ngbTooltip]=\"prevTooltipTpl\"\n      aria-label=\"Previous page\"\n      class=\"page-link\"\n      href\n      (keydown.Space)=\"ngbPagination.selectPage(ngbPagination.page - 1); $event.preventDefault()\"\n      (click)=\"ngbPagination.selectPage(ngbPagination.page - 1); $event.preventDefault()\"\n      [attr.tabindex]=\"ngbPagination.previousDisabled() ? '-1' : null\"\n      [attr.aria-disabled]=\"ngbPagination.previousDisabled() ? 'true' : null\"\n    >\n      <ng-template\n        [ngTemplateOutlet]=\"previous\"\n        [ngTemplateOutletContext]=\"{\n          disabled: ngbPagination.previousDisabled()\n        }\"\n      ></ng-template>\n    </a>\n  </li>\n  <li\n    *ngFor=\"let pageNumber of pages\"\n    class=\"page-item\"\n    [class.active]=\"pageNumber === page\"\n    [class.disabled]=\"ngbPagination.isEllipsis(pageNumber) || disabled\"\n  >\n    <a *ngIf=\"ngbPagination.isEllipsis(pageNumber)\" class=\"page-link\" tabindex=\"-1\" aria-disabled=\"true\">\n      <ng-template\n        [ngTemplateOutlet]=\"ellipsis\"\n        [ngTemplateOutletContext]=\"{ disabled: true, currentPage: page }\"\n      ></ng-template>\n    </a>\n    <a\n      *ngIf=\"!ngbPagination.isEllipsis(pageNumber)\"\n      class=\"page-link\"\n      href\n      [attr.aria-current]=\"pageNumber === page ? 'page' : null\"\n      (keydown.Space)=\"ngbPagination.selectPage(pageNumber); $event.preventDefault()\"\n      (click)=\"ngbPagination.selectPage(pageNumber); $event.preventDefault()\"\n      [attr.tabindex]=\"disabled ? '-1' : null\"\n      [attr.aria-disabled]=\"disabled ? 'true' : null\"\n    >\n      <ng-template\n        [ngTemplateOutlet]=\"defaultNumber\"\n        [ngTemplateOutletContext]=\"{\n          disabled: disabled,\n          $implicit: pageNumber,\n          currentPage: page\n        }\"\n      ></ng-template>\n    </a>\n  </li>\n  <li class=\"page-item\" [class.disabled]=\"ngbPagination.nextDisabled()\">\n    <a\n      [ngbTooltip]=\"nextTooltipTpl\"\n      aria-label=\"Next page\"\n      class=\"page-link\"\n      href\n      (keydown.Space)=\"ngbPagination.selectPage(ngbPagination.page + 1); $event.preventDefault()\"\n      (click)=\"ngbPagination.selectPage(ngbPagination.page + 1); $event.preventDefault()\"\n      [attr.tabindex]=\"ngbPagination.nextDisabled() ? '-1' : null\"\n      [attr.aria-disabled]=\"ngbPagination.nextDisabled() ? 'true' : null\"\n    >\n      <ng-template\n        [ngTemplateOutlet]=\"next\"\n        [ngTemplateOutletContext]=\"{\n          disabled: ngbPagination.nextDisabled(),\n          currentPage: ngbPagination.page\n        }\"\n      ></ng-template>\n    </a>\n  </li>\n</ng-template>\n", directives: [{ type: i1.NgbTooltip, selector: "[ngbTooltip]", inputs: ["animation", "autoClose", "placement", "triggers", "container", "disableTooltip", "tooltipClass", "openDelay", "closeDelay", "ngbTooltip"], outputs: ["shown", "hidden"], exportAs: ["ngbTooltip"] }, { type: i2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }, { type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: NgbA11yPaginationPagesDynamicComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lh-dynamic-pagination-pages', template: "<ng-template #prevTooltipTpl>Previous Page</ng-template>\n<ng-template #nextTooltipTpl>Next Page</ng-template>\n\n<ng-template #previous><span aria-hidden=\"true\">&laquo;</span></ng-template>\n<ng-template #next><span aria-hidden=\"true\">&raquo;</span></ng-template>\n\n<ng-template #defaultNumber let-page let-currentPage=\"currentPage\">\n  <span class=\"visually-hidden\">page </span>\n  {{ page }}\n</ng-template>\n\n<ng-template #ellipsis>...</ng-template>\n\n<ng-template #defaultPages let-page let-pages=\"pages\" let-disabled=\"disabled\">\n  <li class=\"page-item\" [class.disabled]=\"ngbPagination.previousDisabled()\">\n    <a\n      [ngbTooltip]=\"prevTooltipTpl\"\n      aria-label=\"Previous page\"\n      class=\"page-link\"\n      href\n      (keydown.Space)=\"ngbPagination.selectPage(ngbPagination.page - 1); $event.preventDefault()\"\n      (click)=\"ngbPagination.selectPage(ngbPagination.page - 1); $event.preventDefault()\"\n      [attr.tabindex]=\"ngbPagination.previousDisabled() ? '-1' : null\"\n      [attr.aria-disabled]=\"ngbPagination.previousDisabled() ? 'true' : null\"\n    >\n      <ng-template\n        [ngTemplateOutlet]=\"previous\"\n        [ngTemplateOutletContext]=\"{\n          disabled: ngbPagination.previousDisabled()\n        }\"\n      ></ng-template>\n    </a>\n  </li>\n  <li\n    *ngFor=\"let pageNumber of pages\"\n    class=\"page-item\"\n    [class.active]=\"pageNumber === page\"\n    [class.disabled]=\"ngbPagination.isEllipsis(pageNumber) || disabled\"\n  >\n    <a *ngIf=\"ngbPagination.isEllipsis(pageNumber)\" class=\"page-link\" tabindex=\"-1\" aria-disabled=\"true\">\n      <ng-template\n        [ngTemplateOutlet]=\"ellipsis\"\n        [ngTemplateOutletContext]=\"{ disabled: true, currentPage: page }\"\n      ></ng-template>\n    </a>\n    <a\n      *ngIf=\"!ngbPagination.isEllipsis(pageNumber)\"\n      class=\"page-link\"\n      href\n      [attr.aria-current]=\"pageNumber === page ? 'page' : null\"\n      (keydown.Space)=\"ngbPagination.selectPage(pageNumber); $event.preventDefault()\"\n      (click)=\"ngbPagination.selectPage(pageNumber); $event.preventDefault()\"\n      [attr.tabindex]=\"disabled ? '-1' : null\"\n      [attr.aria-disabled]=\"disabled ? 'true' : null\"\n    >\n      <ng-template\n        [ngTemplateOutlet]=\"defaultNumber\"\n        [ngTemplateOutletContext]=\"{\n          disabled: disabled,\n          $implicit: pageNumber,\n          currentPage: page\n        }\"\n      ></ng-template>\n    </a>\n  </li>\n  <li class=\"page-item\" [class.disabled]=\"ngbPagination.nextDisabled()\">\n    <a\n      [ngbTooltip]=\"nextTooltipTpl\"\n      aria-label=\"Next page\"\n      class=\"page-link\"\n      href\n      (keydown.Space)=\"ngbPagination.selectPage(ngbPagination.page + 1); $event.preventDefault()\"\n      (click)=\"ngbPagination.selectPage(ngbPagination.page + 1); $event.preventDefault()\"\n      [attr.tabindex]=\"ngbPagination.nextDisabled() ? '-1' : null\"\n      [attr.aria-disabled]=\"ngbPagination.nextDisabled() ? 'true' : null\"\n    >\n      <ng-template\n        [ngTemplateOutlet]=\"next\"\n        [ngTemplateOutletContext]=\"{\n          disabled: ngbPagination.nextDisabled(),\n          currentPage: ngbPagination.page\n        }\"\n      ></ng-template>\n    </a>\n  </li>\n</ng-template>\n" }]
        }], propDecorators: { tplPages: [{
                type: ViewChild,
                args: ['defaultPages']
            }] } });

class OlNgbA11yPaginationDirective {
    constructor(renderer, el, ngbPagination, liveAnnouncer, viewContainerRef, viewRef, document) {
        this.renderer = renderer;
        this.el = el;
        this.ngbPagination = ngbPagination;
        this.liveAnnouncer = liveAnnouncer;
        this.viewContainerRef = viewContainerRef;
        this.viewRef = viewRef;
        this.document = document;
        this.onDestroy$ = new Subject();
        // We will implement these ourselves in the dynamic component, otherwise we can not target them to apply A11y requirements
        this.ngbPagination.directionLinks = false;
        this.ngbA11yPaginationPagesDynCompRef = this.viewContainerRef.createComponent(NgbA11yPaginationPagesDynamicComponent);
        this.ngbA11yPaginationPagesDynCompRef.instance.ngbPagination = this.ngbPagination;
    }
    ngOnInit() {
        if (typeof this.collectionSize === 'undefined' || !this.collectionSize) {
            throw new Error('OlNgbA11yPaginationDirective requires collectionSize to be a positive integer value');
        }
    }
    ngOnChanges(changes) {
        if (typeof changes['collectionSize'] !== 'undefined' &&
            !changes['collectionSize'].isFirstChange() &&
            changes['collectionSize'].previousValue !== changes['collectionSize'].currentValue) {
            this.updatePageResults();
            this.togglePagerToShowHide(); //  If the amount of results changes (for instance with filtering or searching), we want Pager to dynamically hide/show.
        }
    }
    ngAfterViewInit() {
        const tplPages = this.ngbA11yPaginationPagesDynCompRef.instance.tplPages;
        this.ngbPagination.tplPages = new NgbPaginationPages(tplPages);
        this.viewRef.detectChanges();
        this.appendResultsEl();
        this.updatePageResults();
        this.addClassesToPagesList();
        this.togglePagerToShowHide();
        this.ngbPagination.pageChange.pipe(takeUntil(this.onDestroy$)).subscribe(() => {
            this.updatePageResults();
            void this.announce();
        });
    }
    addClassesToPagesList() {
        this.pagesListEl = this.el.nativeElement.querySelector('.pagination');
        if (!this.pagesListEl || this.pagesListEl === undefined) {
            throw new Error('class="pagination" is required on the list of page links.');
        }
        this.renderer.addClass(this.pagesListEl, 'flex-wrap');
        this.renderer.addClass(this.pagesListEl, 'row-gap-2');
        this.renderer.addClass(this.pagesListEl, 'flex-sm-nowrap');
        this.renderer.addClass(this.pagesListEl, 'gap-sm-0');
    }
    appendResultsEl() {
        this.resultsEl = this.document.createElement('div');
        this.renderer.addClass(this.resultsEl, 'pagination-results');
        this.renderer.addClass(this.resultsEl, 'my-1');
        this.renderer.appendChild(this.el.nativeElement, this.resultsEl);
    }
    /**
     * Method adds or removes Bootstrap 5 d-none utility class to hide Pager when collection size does not warrant visibility.
     */
    togglePagerToShowHide() {
        this.pagerEl = this.el.nativeElement.querySelector('.pagination');
        if (this.ngbPagination.collectionSize <= this.ngbPagination.pageSize) {
            this.renderer.addClass(this.pagerEl, 'd-none');
        }
        else if (this.pagerEl.classList.contains('d-none')) {
            this.renderer.removeClass(this.pagerEl, 'd-none');
        }
    }
    getCurrentResultsRange() {
        const from = this.ngbPagination.pageSize * (this.ngbPagination.page - 1) + 1;
        let to = from + this.ngbPagination.pageSize - 1;
        if (to > this.ngbPagination.collectionSize) {
            to = this.ngbPagination.collectionSize;
        }
        return { from, to };
    }
    updatePageResults() {
        const { from, to } = this.getCurrentResultsRange();
        this.resultsEl.innerHTML = `<span>${from}</span>
                                <span aria-hidden="true">-</span>
                                <span class="visually-hidden">to</span>
                                <span>${to}</span> of ${this.ngbPagination.collectionSize} results`;
    }
    async announce() {
        const { from, to } = this.getCurrentResultsRange();
        return this.liveAnnouncer.announce(`Page changed to ${this.ngbPagination.page} showing ${from} to ${to} of ${this.ngbPagination.collectionSize} results`);
    }
    ngOnDestroy() {
        this.onDestroy$.next();
        this.onDestroy$.complete();
    }
}
OlNgbA11yPaginationDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: OlNgbA11yPaginationDirective, deps: [{ token: i0.Renderer2 }, { token: i0.ElementRef }, { token: i1.NgbPagination }, { token: i2$1.LiveAnnouncer }, { token: i0.ViewContainerRef }, { token: i0.ChangeDetectorRef }, { token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Directive });
OlNgbA11yPaginationDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.4.0", type: OlNgbA11yPaginationDirective, selector: "ngb-pagination:not([ngbDefault])", inputs: { collectionSize: "collectionSize" }, usesOnChanges: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: OlNgbA11yPaginationDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: `ngb-pagination${OPT_OUT_SELECTOR}`,
                }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }, { type: i0.ElementRef }, { type: i1.NgbPagination }, { type: i2$1.LiveAnnouncer }, { type: i0.ViewContainerRef }, { type: i0.ChangeDetectorRef }, { type: Document, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }]; }, propDecorators: { collectionSize: [{
                type: Input
            }] } });

class OlNgbA11yPaginationModule {
}
OlNgbA11yPaginationModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: OlNgbA11yPaginationModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
OlNgbA11yPaginationModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: OlNgbA11yPaginationModule, declarations: [OlNgbA11yPaginationDirective, NgbA11yPaginationPagesDynamicComponent], imports: [CommonModule, NgbTooltipModule], exports: [OlNgbA11yPaginationDirective] });
OlNgbA11yPaginationModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: OlNgbA11yPaginationModule, imports: [[CommonModule, NgbTooltipModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: OlNgbA11yPaginationModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [OlNgbA11yPaginationDirective, NgbA11yPaginationPagesDynamicComponent],
                    exports: [OlNgbA11yPaginationDirective],
                    imports: [CommonModule, NgbTooltipModule],
                }]
        }] });

class NgbDropdownToggleNoCaretDirective {
    constructor(el, renderer) {
        this.el = el;
        this.renderer = renderer;
    }
    ngOnInit() {
        this.renderer.removeClass(this.el.nativeElement, 'dropdown-toggle');
    }
}
NgbDropdownToggleNoCaretDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: NgbDropdownToggleNoCaretDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Directive });
NgbDropdownToggleNoCaretDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.4.0", type: NgbDropdownToggleNoCaretDirective, selector: "[ngbDropdownToggle][noCaret], [ngbDropdownAnchor][noCaret]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: NgbDropdownToggleNoCaretDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[ngbDropdownToggle][noCaret], [ngbDropdownAnchor][noCaret]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }]; } });

const HEX_BASE = 36;
const HASH_LENGTH = 7;
class NgbA11yDropMenuDirective {
    constructor(dropdown, _renderer) {
        this.dropdown = dropdown;
        this._renderer = _renderer;
        this.destroy$ = new Subject();
        // must be unique per page
        this.dropMenuId = 'drop-menu-' + NgbA11yDropMenuDirective._generateUniqueId();
    }
    // Create string of random characters to ensure unique ID
    static _generateUniqueId() {
        return (Math.random() * 100).toString(HEX_BASE).substring(HASH_LENGTH);
    }
    ngAfterViewInit() {
        // Ensure correct structure
        if (this.dropdownMenu === undefined) {
            console.error('ngbA11yDropMenu found no ngbDropdownMenu');
            return;
        }
        if (this.dropdownToggle === undefined) {
            console.error('ngbA11yDropMenu found no ngbDropdownToggle');
            return;
        }
        if (this.dropdownMenu.menuItems?.length < 1) {
            console.error('ngbA11yDropMenu found no ngbDropdownMenuItems');
            return;
        }
        const dropdownMenuEl = this.dropdownMenu.nativeElement;
        const dropdownToggleEl = this.dropdownToggle.nativeElement;
        // Add aria-haspopup=true to toggle, add ID to menu
        // and point toggle aria-controls to menu
        dropdownToggleEl.ariaHasPopup = 'true';
        dropdownMenuEl.id = this.dropMenuId;
        dropdownToggleEl.setAttribute('aria-controls', this.dropMenuId);
        // Add ID to toggle Point menu aria-labelledby to button
        const toggleId = `${this.dropMenuId}-toggle`;
        dropdownToggleEl.id = toggleId;
        if (!dropdownMenuEl.getAttribute('aria-label')) {
            dropdownMenuEl.setAttribute('aria-labelledby', toggleId);
        }
        // Add menu and menuitem roles
        dropdownMenuEl.setAttribute('role', 'menu');
        // prep the items in the menu
        this.applyMarkupToMenuItems();
        // subscribe to updates so we can reapply if the list changes
        this.dropdownMenu.menuItems.changes.pipe(takeUntil(this.destroy$)).subscribe(() => {
            this.applyMarkupToMenuItems();
        });
        // On open, move focus to first menuitem
        this.dropdown.openChange.pipe(takeUntil(this.destroy$)).subscribe((isOpen) => {
            if (isOpen) {
                // Timer required as Dropdown component moves focus to toggle after firing open event
                timer(0).subscribe(() => {
                    this.dropdownMenu?.menuItems.first.elementRef.nativeElement.focus();
                });
            }
        });
        const isBody = this.dropdown.container === 'body';
        // Manage special cases for TAB poress
        fromEvent(dropdownMenuEl, 'keydown')
            .pipe(filter((event) => event.key === 'Tab'), takeUntil(this.destroy$))
            .subscribe((event) => {
            // If container is body, need to move focus back to toggle, as is not in normal focus order
            if (isBody) {
                dropdownToggleEl.focus();
            }
            // If shift press or body container, ensure menu closed
            if (isBody || event.shiftKey) {
                if (this.dropdown.isOpen()) {
                    this.dropdown.close();
                }
            }
            // Should stop propagation if body container and shift press
            // to prevent moving to previous focusable entity
            if (isBody && event.shiftKey) {
                event.preventDefault();
            }
        });
    }
    applyMarkupToMenuItems() {
        this.dropdownMenu?.menuItems.forEach((item) => {
            const itemEl = item.elementRef.nativeElement;
            this._renderer.setAttribute(itemEl, 'role', 'menuitem');
            this._renderer.setAttribute(itemEl, 'tabIndex', '-1');
        });
    }
    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
NgbA11yDropMenuDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: NgbA11yDropMenuDirective, deps: [{ token: i1.NgbDropdown }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Directive });
NgbA11yDropMenuDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.4.0", type: NgbA11yDropMenuDirective, selector: "[ngbDropdown][olNgbA11yDropMenu]", inputs: { dropMenuId: "dropMenuId" }, queries: [{ propertyName: "dropdownMenu", first: true, predicate: NgbDropdownMenu, descendants: true }, { propertyName: "dropdownToggle", first: true, predicate: NgbDropdownToggle, descendants: true }], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: NgbA11yDropMenuDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[ngbDropdown][olNgbA11yDropMenu]',
                }]
        }], ctorParameters: function () { return [{ type: i1.NgbDropdown }, { type: i0.Renderer2 }]; }, propDecorators: { dropdownMenu: [{
                type: ContentChild,
                args: [NgbDropdownMenu]
            }], dropdownToggle: [{
                type: ContentChild,
                args: [NgbDropdownToggle]
            }], dropMenuId: [{
                type: Input
            }] } });

const public_declarations$1 = [NgbDropdownToggleNoCaretDirective, NgbA11yDropMenuDirective];
class NgbA11yDropdownModule {
}
NgbA11yDropdownModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: NgbA11yDropdownModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
NgbA11yDropdownModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: NgbA11yDropdownModule, declarations: [NgbDropdownToggleNoCaretDirective, NgbA11yDropMenuDirective], imports: [NgbDropdownModule], exports: [NgbDropdownModule, NgbDropdownToggleNoCaretDirective, NgbA11yDropMenuDirective] });
NgbA11yDropdownModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: NgbA11yDropdownModule, imports: [[NgbDropdownModule], NgbDropdownModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: NgbA11yDropdownModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [NgbDropdownModule],
                    declarations: [...public_declarations$1],
                    exports: [NgbDropdownModule, ...public_declarations$1],
                }]
        }] });

class NavigationTabIndexDirective {
    constructor(renderer, nav) {
        this.renderer = renderer;
        this.nav = nav;
        this.subscriptions = new Subscription();
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    ngAfterViewInit() {
        this.nav.links.forEach((l) => {
            this.subscriptions.add(this.renderer.listen(l.elRef.nativeElement, 'keydown', (event) => {
                if (event.code === 'Space') {
                    this.nav?.select(l.navItem.id);
                    event.preventDefault();
                }
            }));
        });
        // This block of code sets active tab tabIndex = 0 and all other nav links tabIndex = -1 when nav active id is changed.
        // Hence when key board user navigates through nav list, TAB navigates into and out of the tab list, RIGHT ARROW and LEFT ARROW navigate between the tabs in a tab list.
        this.subscriptions.add(this.nav.activeIdChange
            .pipe(startWith(this.nav.activeId), tap(() => {
            this.nav?.links.forEach(({ elRef, navItem }) => {
                elRef.nativeElement.tabIndex = navItem.active ? 0 : -1;
            });
        }))
            .subscribe());
    }
}
NavigationTabIndexDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: NavigationTabIndexDirective, deps: [{ token: i0.Renderer2 }, { token: i1.NgbNav }], target: i0.ɵɵFactoryTarget.Directive });
NavigationTabIndexDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.4.0", type: NavigationTabIndexDirective, selector: "[ngbNav]:not([ngbDefault])", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: NavigationTabIndexDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: `[ngbNav]${OPT_OUT_SELECTOR}`,
                }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }, { type: i1.NgbNav }]; } });

class NgbA11yTabIndexModule {
}
NgbA11yTabIndexModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: NgbA11yTabIndexModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
NgbA11yTabIndexModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: NgbA11yTabIndexModule, declarations: [NavigationTabIndexDirective], imports: [CommonModule, NgbNavModule, NgbModule], exports: [NavigationTabIndexDirective] });
NgbA11yTabIndexModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: NgbA11yTabIndexModule, imports: [[CommonModule, NgbNavModule, NgbModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: NgbA11yTabIndexModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [NavigationTabIndexDirective],
                    exports: [NavigationTabIndexDirective],
                    imports: [CommonModule, NgbNavModule, NgbModule],
                }]
        }] });

class NavigationRouterOutletDirective {
    constructor(renderer, nav) {
        this.renderer = renderer;
        this.nav = nav;
        this.subscriptions = new Subscription();
    }
    ngAfterViewInit() {
        this.subscriptions.add(this.nav.activeIdChange
            .pipe(startWith(this.nav.activeId), tap(() => {
            this.nav?.links.forEach((l) => {
                timer(0).subscribe(() => {
                    this.renderer.removeAttribute(l.elRef.nativeElement, 'aria-controls');
                });
            });
        }))
            .subscribe());
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
}
NavigationRouterOutletDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: NavigationRouterOutletDirective, deps: [{ token: i0.Renderer2 }, { token: i1.NgbNav }], target: i0.ɵɵFactoryTarget.Directive });
NavigationRouterOutletDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.4.0", type: NavigationRouterOutletDirective, selector: "[ngbNav][ngbA11yRouterOutletNav]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: NavigationRouterOutletDirective, decorators: [{
            type: Directive,
            args: [{
                    // eslint-disable-next-line @angular-eslint/directive-selector
                    selector: '[ngbNav][ngbA11yRouterOutletNav]',
                }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }, { type: i1.NgbNav }]; } });

class NgbA11yRouterOutletNavModule {
}
NgbA11yRouterOutletNavModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: NgbA11yRouterOutletNavModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
NgbA11yRouterOutletNavModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: NgbA11yRouterOutletNavModule, declarations: [NavigationRouterOutletDirective], imports: [NgbNavModule], exports: [NavigationRouterOutletDirective] });
NgbA11yRouterOutletNavModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: NgbA11yRouterOutletNavModule, imports: [[NgbNavModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: NgbA11yRouterOutletNavModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [NavigationRouterOutletDirective],
                    exports: [NavigationRouterOutletDirective],
                    imports: [NgbNavModule],
                }]
        }] });

const rotate = {
    ascending: 'descending',
    descending: 'ascending',
};
class OlNgbA11ySortableHeaderDirective {
    constructor(el, renderer) {
        this.el = el;
        this.renderer = renderer;
        // ID of column to be emitted when sorted
        this.olNgbA11ySortable = '';
        // Emitted when sort triggered by click or initial sort. Note that
        // this directive does NOT actually sort the content of the table,
        // that is up to the table using the directive
        this.sort = new EventEmitter();
        this._iconElement = this.renderer.createElement('i');
    }
    ngOnInit() {
        // Fire initial sort if specified
        if (this.direction !== undefined) {
            this.sort.emit({
                column: this.olNgbA11ySortable,
                direction: this.direction,
            });
        }
    }
    ngAfterViewInit() {
        // Check for valid structure
        const headerButton = this.el.nativeElement.querySelector('button');
        if (headerButton === null) {
            console.error('olNgbA11ySortable header contains no button');
            return;
        }
        // Add icon element to contained button
        this.renderer.addClass(this._iconElement, 'bi');
        this.renderer.insertBefore(headerButton, this._iconElement, headerButton.firstChild);
        this._renderSort();
    }
    rotate() {
        if (this.direction !== undefined) {
            this.direction = rotate[this.direction];
        }
        else {
            this.direction = 'ascending';
        }
        this._renderSort();
        this.sort.emit({
            column: this.olNgbA11ySortable,
            direction: this.direction,
        });
    }
    removeSort() {
        this.direction = undefined;
        this._renderSort();
    }
    // Set aria sort and change the icon for sort direction
    _renderSort() {
        const sortDirection = this.direction ?? 'none';
        this.renderer.setAttribute(this.el.nativeElement, 'aria-sort', sortDirection);
        // Remove existing icon
        this.renderer.removeClass(this._iconElement, 'bi-chevron-up');
        this.renderer.removeClass(this._iconElement, 'bi-chevron-down');
        this.renderer.removeClass(this._iconElement, 'bi-chevron-expand');
        // Set icon based on direction
        let iconClass;
        switch (this.direction) {
            case 'ascending':
                iconClass = 'bi-chevron-up';
                break;
            case 'descending':
                iconClass = 'bi-chevron-down';
                break;
            default:
                iconClass = 'bi-chevron-expand';
                break;
        }
        this.renderer.addClass(this._iconElement, iconClass);
    }
}
OlNgbA11ySortableHeaderDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: OlNgbA11ySortableHeaderDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Directive });
OlNgbA11ySortableHeaderDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.4.0", type: OlNgbA11ySortableHeaderDirective, selector: "th[olNgbA11ySortable]", inputs: { olNgbA11ySortable: "olNgbA11ySortable", direction: "direction" }, outputs: { sort: "sort" }, host: { listeners: { "click": "rotate()" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: OlNgbA11ySortableHeaderDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'th[olNgbA11ySortable]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }]; }, propDecorators: { olNgbA11ySortable: [{
                type: Input
            }], direction: [{
                type: Input
            }], sort: [{
                type: Output
            }], rotate: [{
                type: HostListener,
                args: ['click']
            }] } });

/**
 * Table should contain column(s) with th[olNgbA11ySortable] directive
 */
class OlNgbA11ySortableTableDirective {
    constructor() {
        this.destroy$ = new Subject();
    }
    onSort({ column, direction }) {
        // Remove aria-sort for columns other than that being sorted
        this.headers?.forEach((header) => {
            if (header.olNgbA11ySortable !== column) {
                header.removeSort();
            }
            else {
                if (!direction) {
                    header.removeSort();
                }
            }
        });
    }
    ngAfterContentInit() {
        // Add subscriptions for sort for each child header
        this.headers?.forEach((header) => {
            header.sort.pipe(takeUntil(this.destroy$)).subscribe((sortEvent) => {
                this.onSort(sortEvent);
            });
        });
    }
    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
OlNgbA11ySortableTableDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: OlNgbA11ySortableTableDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
OlNgbA11ySortableTableDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.4.0", type: OlNgbA11ySortableTableDirective, selector: "table[olNgbA11ySortable]", queries: [{ propertyName: "headers", predicate: OlNgbA11ySortableHeaderDirective, descendants: true }], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: OlNgbA11ySortableTableDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'table[olNgbA11ySortable]',
                }]
        }], propDecorators: { headers: [{
                type: ContentChildren,
                args: [OlNgbA11ySortableHeaderDirective, { descendants: true }]
            }] } });

class OlNgbA11ySortableTableModule {
}
OlNgbA11ySortableTableModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: OlNgbA11ySortableTableModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
OlNgbA11ySortableTableModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: OlNgbA11ySortableTableModule, declarations: [OlNgbA11ySortableHeaderDirective, OlNgbA11ySortableTableDirective], exports: [OlNgbA11ySortableHeaderDirective, OlNgbA11ySortableTableDirective] });
OlNgbA11ySortableTableModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: OlNgbA11ySortableTableModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: OlNgbA11ySortableTableModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [OlNgbA11ySortableHeaderDirective, OlNgbA11ySortableTableDirective],
                    exports: [OlNgbA11ySortableHeaderDirective, OlNgbA11ySortableTableDirective],
                }]
        }] });

class OlGridWidgetDirective {
    constructor(elementRef) {
        this.elementRef = elementRef;
        this.isValueSet = false;
        // ID of column to be emitted for setting and resetting
        this.olGridWidget = '';
        // Validity of select validations for which exiting of edit mode needs to blocked if invalid
        this.isValidInput = true;
        this.asyncFn = null;
        this.reset = new EventEmitter();
        this.set = new EventEmitter();
        this.activeNodeEl = null;
    }
    handleKeyDown(event) {
        if (event.key === 'Escape' && this.isValueSet) {
            this.reset.emit({
                column: this.olGridWidget,
            });
            this.isValueSet = false;
        }
        else if ((event.key === 'Enter' || event.key === 'F2') && this.isValidInput) {
            this.isValueSet = !this.isValueSet;
            this.set.emit({
                column: this.olGridWidget,
                isEditMode: this.isValueSet,
            });
        }
        else {
            // Trap focus
            const isTabPressed = event.key === 'Tab';
            if (!isTabPressed) {
                return;
            }
            const widgetGroupNode = this.elementRef.nativeElement.querySelector('.widget-group');
            const focusableElements = widgetGroupNode?.querySelectorAll('[tabindex]');
            const firstFocusableElement = focusableElements?.[0];
            const lastFocusableElement = focusableElements?.[focusableElements.length - 1];
            if (event.shiftKey) {
                // Shift + Tab
                if (document.activeElement === firstFocusableElement) {
                    event.preventDefault();
                    lastFocusableElement?.focus();
                }
            }
            else {
                // Tab
                if (document.activeElement === lastFocusableElement) {
                    event.preventDefault();
                    firstFocusableElement?.focus();
                }
            }
        }
    }
    emitResponse(response) {
        this.set.emit({
            column: this.olGridWidget,
            isEditMode: false,
            data: response,
        });
    }
    handleClick() {
        if (!this.isValueSet && !this.activeNodeEl) {
            this.isValueSet = true;
            this.set.emit({
                column: this.olGridWidget,
                isEditMode: this.isValueSet,
            });
        }
    }
    handleOutsideClick(event) {
        event.stopPropagation();
        const clickedElement = event.target;
        const widgetContainer = this.elementRef.nativeElement;
        if (!clickedElement.contains(widgetContainer) &&
            !widgetContainer.contains(clickedElement) &&
            this.isValueSet &&
            this.isValidInput) {
            this.isValueSet = false;
            this.set.emit({
                column: this.olGridWidget,
                isEditMode: this.isValueSet,
            });
        }
    }
}
OlGridWidgetDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: OlGridWidgetDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
OlGridWidgetDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.4.0", type: OlGridWidgetDirective, selector: "td[olGridWidget]", inputs: { olGridWidget: "olGridWidget", isValidInput: "isValidInput", asyncFn: "asyncFn" }, outputs: { reset: "reset", set: "set" }, host: { listeners: { "keydown": "handleKeyDown($event)", "click": "handleClick()", "window:click": "handleOutsideClick($event)" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: OlGridWidgetDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'td[olGridWidget]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { olGridWidget: [{
                type: Input
            }], isValidInput: [{
                type: Input
            }], asyncFn: [{
                type: Input
            }], reset: [{
                type: Output
            }], set: [{
                type: Output
            }], handleKeyDown: [{
                type: HostListener,
                args: ['keydown', ['$event']]
            }], handleClick: [{
                type: HostListener,
                args: ['click']
            }], handleOutsideClick: [{
                type: HostListener,
                args: ['window:click', ['$event']]
            }] } });

class AriaGrid {
    constructor(gridNode) {
        this.GridSelector = {
            ROW: 'tr, [role="row"]',
            CELL: 'th, td, [role="gridcell"]',
            SCROLL_ROW: 'tr:not([data-fixed]), [role="row"]',
            SORT_HEADER: 'th[aria-sort]',
            TABBABLE: '[tabindex="0"]',
        };
        this.KeyCode = {
            BACKSPACE: 8,
            TAB: 9,
            RETURN: 13,
            SHIFT: 16,
            ESC: 27,
            SPACE: 32,
            PAGE_UP: 33,
            PAGE_DOWN: 34,
            END: 35,
            HOME: 36,
            LEFT: 37,
            UP: 38,
            RIGHT: 39,
            DOWN: 40,
            DELETE: 46,
            F2: 113,
        };
        this.CSSClass = {
            HIDDEN: 'd-none',
        };
        this.grid = [];
        this.isRowSpanGrid = false;
        this.indicesOfColWithRowSpan = [];
        this.focusTrappedElements = [];
        this.oldDateString = '';
        this.isAsyncInProgress = false;
        this.checkFocusChange = (event) => {
            // For ngbdropdownitem target, let ngb manage the navigation
            if (event.target.matches('[ngbdropdownitem]')) {
                return;
            }
            if (!event || this.navigationDisabled) {
                return;
            }
            this.findFocusedItem(event.target);
            const key = event.key;
            let rowCaret = this.focusedRow;
            let colCaret = this.focusedCol;
            let nextCell;
            switch (key) {
                case 'ArrowUp':
                    nextCell = this.getNextVisibleCell(0, -1);
                    if (nextCell) {
                        rowCaret = nextCell.row;
                        colCaret = nextCell.col;
                    }
                    break;
                case 'ArrowDown':
                    nextCell = this.getNextVisibleCell(0, 1);
                    if (nextCell) {
                        rowCaret = nextCell.row;
                        colCaret = nextCell.col;
                    }
                    break;
                case 'ArrowLeft':
                    nextCell = this.getNextVisibleCell(-1, 0);
                    if (nextCell) {
                        rowCaret = nextCell.row;
                        colCaret = nextCell.col;
                    }
                    break;
                case 'ArrowRight':
                    nextCell = this.getNextVisibleCell(1, 0);
                    if (nextCell) {
                        rowCaret = nextCell.row;
                        colCaret = nextCell.col;
                    }
                    break;
                case 'Home':
                    if (event.ctrlKey) {
                        rowCaret = 0;
                    }
                    colCaret = 0;
                    break;
                case 'End':
                    if (event.ctrlKey) {
                        rowCaret = this.grid.length - 1;
                    }
                    colCaret = this.grid[this.focusedRow].length - 1;
                    break;
                default:
                    return;
            }
            this.focusCell(rowCaret, colCaret);
            event.preventDefault();
        };
        this.handleClickOutside = (event) => {
            // Check if the click is outside the target element and its descendants
            if (this.activeNode &&
                !this.activeNode.contains(event.target) &&
                !this.isAsyncInProgress) {
                const closestEditableText = this.findClosest(this.activeNode, '.form-control-editable-text');
                if (closestEditableText) {
                    this.toggleEditMode(closestEditableText, false, true, false);
                }
                // Removing listener when not in edit mode to take care of performance
                document.removeEventListener('click', this.handleClickOutside);
            }
        };
        this.delegateButtonHandler = (event) => {
            const key = event instanceof KeyboardEvent ? event.which || event.keyCode : null;
            const target = event.target;
            const isClickEvent = event.type === 'click';
            if (!target) {
                return;
            }
            if (this.findClosest(target, '.form-control-editable-text') &&
                !this.findClosest(target, '.widget-group') &&
                (isClickEvent || key === this.KeyCode.RETURN || key === this.KeyCode.F2)) {
                event.preventDefault();
                const closestEditableText = this.findClosest(target, '.form-control-editable-text');
                if (closestEditableText && !this.activeNode) {
                    this.toggleEditMode(closestEditableText, true, false);
                }
            }
            if ((target.matches('.form-control') &&
                (key === this.KeyCode.RETURN || key === this.KeyCode.ESC || key === this.KeyCode.F2)) ||
                (this.findClosest(target, '.widget-group') && (key === this.KeyCode.ESC || key === this.KeyCode.F2))) {
                event.preventDefault();
                const closestEditableText = this.findClosest(target, '.form-control-editable-text');
                if (closestEditableText) {
                    this.toggleEditMode(closestEditableText, false, key === this.KeyCode.RETURN || key === this.KeyCode.F2);
                }
            }
        };
        this.navigationDisabled = false;
        this.gridNode = gridNode;
        this.setupFocusGrid();
        this.setFocusPointer(0, 0);
        this.registerEvents();
    }
    findFocusedItem(focusedTarget) {
        const focusedCell = this.grid[this.focusedRow]?.[this.focusedCol];
        if ((focusedCell === focusedTarget || focusedCell?.contains(focusedTarget)) &&
            focusedTarget?.getAttribute('tabindex') === '0') {
            return;
        }
        for (let i = 0; i < this.grid.length; i++) {
            for (let j = 0; j < this.grid[i].length; j++) {
                if (this.grid[i][j] === focusedTarget || this.grid[i][j].contains(focusedTarget)) {
                    this.setFocusPointer(i, j);
                    return;
                }
            }
        }
    }
    getNextVisibleCell(directionX, directionY) {
        const nextCell = this.getNextCell(this.focusedRow, this.focusedCol, directionX, directionY);
        if (!nextCell) {
            return false;
        }
        return nextCell;
    }
    getNextCell(currRow, currCol, directionX, directionY) {
        let row = currRow + directionY;
        const col = currCol + directionX;
        const rowCount = this.grid.length;
        if (this.isRowSpanGrid) {
            if (this.indicesOfColWithRowSpan.includes(currCol) && currRow === 0 && directionY === 1) {
                row = currRow + directionY + 1;
            }
            if (this.indicesOfColWithRowSpan.includes(currCol) && currRow === 2 && directionY === -1) {
                row = currRow + directionY - 1;
            }
        }
        if (!rowCount) {
            return false;
        }
        if (this.isValidCell(row, col)) {
            return {
                row: row,
                col: col,
            };
        }
        else if (this.isValidCell(currRow, currCol)) {
            return {
                row: currRow,
                col: currCol,
            };
        }
        else {
            return false;
        }
    }
    focusCell(row, col) {
        if (this.setFocusPointer(row, col, true)) {
            this.grid[row][col].focus();
        }
    }
    setupFocusGrid() {
        this.grid = [];
        const rows = this.gridNode.querySelectorAll(this.GridSelector.ROW);
        rows.forEach((row) => {
            const rowCells = [];
            const cells = row.querySelectorAll(this.GridSelector.CELL);
            cells.forEach((cell) => {
                const focusableSelector = '[tabindex]';
                if (cell.matches(focusableSelector)) {
                    rowCells.push(cell);
                }
                else {
                    const focusableCell = cell.querySelector(focusableSelector);
                    if (focusableCell && (focusableCell.matches('a') || focusableCell.matches('i'))) {
                        const focusableCells = cell.querySelectorAll(focusableSelector);
                        if (focusableCells.length) {
                            focusableCells.forEach((el) => rowCells.push(el));
                        }
                    }
                    else if (focusableCell) {
                        rowCells.push(focusableCell);
                    }
                }
            });
            if (rowCells.length) {
                this.grid.push(rowCells);
            }
        });
        this.updateGridForHeaderWithLinks();
    }
    updateGridForHeaderWithLinks() {
        this.indicesOfColWithRowSpan = this.grid[0].reduce((indices, cell, index) => {
            if (cell.parentElement && cell.parentElement.matches('[rowspan]')) {
                indices.push(index);
            }
            return indices;
        }, []);
        if (this.indicesOfColWithRowSpan.length) {
            this.isRowSpanGrid = true;
            const rowIndex = 1;
            const modifiedRow = [];
            let oriIndex = 0;
            let colIndex = 0;
            for (let index = 0; index < this.grid[0].length; colIndex++) {
                if (this.indicesOfColWithRowSpan.includes(index)) {
                    modifiedRow.push(this.grid[rowIndex - 1][colIndex]);
                }
                else {
                    modifiedRow.push(this.grid[rowIndex][oriIndex]);
                    oriIndex++;
                }
                index++;
            }
            this.grid[rowIndex] = modifiedRow;
        }
    }
    setFocusPointer(row, col, isScrollToViewPort = false) {
        if (!this.isValidCell(row, col)) {
            return false;
        }
        if (!isNaN(this.focusedRow) && !isNaN(this.focusedCol)) {
            this.grid[this.focusedRow]?.[this.focusedCol]?.setAttribute('tabindex', '-1');
        }
        this.grid[row][col].setAttribute('tabindex', '0');
        this.focusedRow = row;
        this.focusedCol = col;
        if (isScrollToViewPort) {
            this.focusElementInViewport(this.grid[row][col]);
        }
        return true;
    }
    isValidCell(row, col) {
        return (!isNaN(row) &&
            !isNaN(col) &&
            row >= 0 &&
            col >= 0 &&
            this.grid &&
            !!this.grid.length &&
            row < this.grid.length &&
            col < this.grid[row].length);
    }
    focusElementInViewport(element) {
        if (element) {
            element.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
                inline: 'nearest',
            });
        }
    }
    findClosest(element, selector) {
        while (element) {
            if (element.matches(selector)) {
                return element;
            }
            element = element.parentElement;
        }
        return null;
    }
    toggleEditMode(editCell, toggleOn, updateText, setFocus = true) {
        const onClassName = toggleOn ? 'form-control' : 'form-control-editable-text-button';
        const offClassName = toggleOn ? 'form-control-editable-text-button' : 'form-control';
        const onNode = editCell.querySelector('.' + onClassName);
        const offNode = editCell.querySelector('.' + offClassName);
        let currentWidget;
        let isValidInput;
        if (this.gridWidgets?.length) {
            currentWidget = this.gridWidgets?.find((widget) => widget.elementRef.nativeElement.contains(offNode));
            isValidInput = currentWidget?.isValidInput;
        }
        else {
            const tdEl = editCell.parentElement;
            const widgetDirectiveIndex = tdEl?.__ngContext__.findIndex((item) => item instanceof OlGridWidgetDirective);
            if (widgetDirectiveIndex >= 0) {
                isValidInput = tdEl.__ngContext__[widgetDirectiveIndex].isValidInput;
            }
        }
        if (!isValidInput && updateText) {
            const errorMsgElIds = offNode.getAttribute('aria-describedby') || '';
            offNode.removeAttribute('aria-describedby');
            // Timer needed to have a significant gap between removal and adding of the attribute so that it is announced
            setTimeout(() => {
                offNode.setAttribute('aria-describedby', errorMsgElIds);
            }, 100);
            return;
        }
        if (currentWidget?.asyncFn && !toggleOn && !this.isAsyncInProgress && updateText) {
            this.addLoader(offNode);
            this.isAsyncInProgress = true;
            currentWidget.asyncFn().subscribe({
                next: (data) => {
                    currentWidget?.emitResponse(data);
                    this.removeLoader(offNode);
                    this.isAsyncInProgress = false;
                    this.processToggling(editCell, toggleOn, offNode, onNode, setFocus);
                },
                error: (error) => {
                    currentWidget?.emitResponse(error);
                    this.removeLoader(offNode);
                    this.isAsyncInProgress = false;
                    this.processToggling(editCell, toggleOn, offNode, onNode, setFocus);
                },
            });
        }
        else {
            this.processToggling(editCell, toggleOn, offNode, onNode, setFocus);
        }
    }
    processToggling(editCell, toggleOn, offNode, onNode, setFocus) {
        // Handle widget group
        const focusableEl = '[tabindex]';
        const widgetGroupNodeClass = 'widget-group';
        const widgetControls = editCell.querySelectorAll(focusableEl);
        const widgetGroupNode = editCell.querySelector('.' + widgetGroupNodeClass);
        if (widgetGroupNode) {
            widgetControls.forEach((control) => {
                if (toggleOn) {
                    this.removeClass(widgetGroupNode, this.CSSClass.HIDDEN);
                    control.setAttribute('tabindex', '0');
                }
                else {
                    this.addClass(widgetGroupNode, this.CSSClass.HIDDEN);
                    control.setAttribute('tabindex', '-1');
                }
            });
        }
        this.addClass(offNode, this.CSSClass.HIDDEN);
        this.removeClass(onNode, this.CSSClass.HIDDEN);
        offNode.setAttribute('tabindex', '-1');
        onNode.setAttribute('tabindex', '0');
        if (onNode instanceof HTMLElement && setFocus) {
            onNode.focus();
            if (onNode instanceof HTMLInputElement) {
                onNode.select();
            }
        }
        this.grid[this.focusedRow][this.focusedCol] = onNode;
        this.navigationDisabled = toggleOn;
        if (toggleOn) {
            document.addEventListener('click', this.handleClickOutside);
            // Timer needed to avoid issue of exiting edit mode immediately after toggling it
            setTimeout(() => {
                this.activeNode = onNode;
                this.updateGridwidgets();
            }, 0);
        }
        else {
            this.activeNode = null;
            this.updateGridwidgets();
        }
    }
    addLoader(el) {
        const buttonElement = document.createElement('button');
        buttonElement.className = 'btn btn-primary';
        buttonElement.type = 'button';
        buttonElement.disabled = true;
        buttonElement.setAttribute('role', 'status');
        const firstSpan = document.createElement('span');
        firstSpan.className = 'spinner-border spinner-border-sm';
        firstSpan.setAttribute('aria-hidden', 'true');
        const secondSpan = document.createElement('span');
        secondSpan.className = 'visually-hidden';
        secondSpan.textContent = 'Saving...';
        buttonElement.appendChild(firstSpan);
        const targetDiv = el.parentElement;
        targetDiv?.appendChild(buttonElement);
        // Timer needed for SR announcments
        setTimeout(() => {
            buttonElement.appendChild(secondSpan);
        }, 100);
    }
    removeLoader(el) {
        const targetDiv = el.parentElement;
        const buttonElement = targetDiv?.querySelector('button');
        buttonElement && targetDiv?.removeChild(buttonElement);
    }
    updateGridwidgets() {
        this.gridWidgets?.forEach((widget) => {
            widget.activeNodeEl = this.activeNode;
        });
    }
    hasClass(element, className) {
        return new RegExp('(\\s|^)' + className + '(\\s|$)').test(element.className);
    }
    addClass(element, className) {
        if (!this.hasClass(element, className)) {
            element.classList.add(className);
        }
    }
    removeClass(element, className) {
        const classRegex = new RegExp('(\\s|^)' + className + '(\\s|$)');
        element.className = element.className.replace(classRegex, ' ').trim();
    }
    registerEvents() {
        this.gridNode.addEventListener('keydown', this.checkFocusChange);
        this.gridNode.addEventListener('keydown', this.delegateButtonHandler);
        this.gridNode.addEventListener('click', this.delegateButtonHandler);
    }
}

/**
 * Table should contain column(s) with th[olNgbA11yGridSortable] directive
 */
class OlNgbA11ySortableDataGridDirective {
    constructor(elementRef) {
        this.elementRef = elementRef;
        this.destroy$ = new Subject();
        this.config = { attributes: true, childList: true, subtree: true };
        this.isPointerSet = false;
        this.gridEl = this.elementRef.nativeElement;
    }
    ngAfterContentInit() {
        if (this.gridEl) {
            this.ariaGrid = new AriaGrid(this.gridEl);
            this.ariaGrid.gridWidgets = this.gridWidgets;
        }
        // Add subscriptions for sort for each child header
        this.headers?.forEach((header) => {
            header.sort.pipe(takeUntil(this.destroy$)).subscribe((sortEvent) => {
                this.onSort(sortEvent);
            });
        });
        // Create a MutationObserver instance
        this.observer = new MutationObserver((mutationsList) => {
            for (const mutation of mutationsList) {
                if (mutation.type === 'attributes') {
                    this.ariaGrid.setupFocusGrid();
                    if (!this.isPointerSet) {
                        this.ariaGrid.setFocusPointer(0, 0);
                        this.isPointerSet = true;
                    }
                    else {
                        if (mutation.attributeName === 'aria-sort') {
                            this.ariaGrid.setFocusPointer(this.ariaGrid.focusedRow, this.ariaGrid.focusedCol);
                        }
                        else if (mutation.target.matches('div') ||
                            mutation.target.matches('ngb-tooltip-window')) {
                            this.observer.disconnect();
                            timer(10) // observe mutations again after allowing dropdown div changes to be completed
                                .pipe(take(1))
                                .subscribe(() => {
                                this.observer.observe(this.elementRef.nativeElement, this.config);
                            });
                        }
                        else {
                            const targetEl = this.ariaGrid.grid[this.ariaGrid.focusedRow]?.[this.ariaGrid.focusedCol] ??
                                this.ariaGrid.grid[0][0];
                            this.ariaGrid.findFocusedItem(targetEl);
                        }
                    }
                    break;
                }
            }
        });
        // Start observing the target node for configured changes
        this.observer.observe(this.elementRef.nativeElement, this.config);
    }
    onSort({ column, direction }) {
        // Remove aria-sort for columns other than that being sorted
        this.headers?.forEach((header) => {
            if (header.olNgbA11ySortable !== column) {
                header.removeSort();
            }
            else {
                if (!direction) {
                    header.removeSort();
                }
            }
        });
    }
    handleKeyDown(event) {
        const targetEl = event.target;
        if (targetEl.matches('button[ngbdropdowntoggle]') &&
            (event.key === 'ArrowUp' || event.key === 'ArrowDown')) {
            const ngbDropdownEl = targetEl.parentElement;
            const ngbDropdownIndex = ngbDropdownEl?.__ngContext__.findIndex((item) => item instanceof NgbDropdown);
            // Close drop-menu while navigating through the grid
            if (ngbDropdownIndex >= 0)
                ngbDropdownEl.__ngContext__[ngbDropdownIndex].close();
        }
    }
    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
        this.observer.disconnect();
    }
}
OlNgbA11ySortableDataGridDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: OlNgbA11ySortableDataGridDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
OlNgbA11ySortableDataGridDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.4.0", type: OlNgbA11ySortableDataGridDirective, selector: "table[olNgbA11yGridSortable]", host: { listeners: { "keydown": "handleKeyDown($event)" } }, queries: [{ propertyName: "headers", predicate: OlNgbA11ySortableHeaderDirective, descendants: true }, { propertyName: "gridWidgets", predicate: OlGridWidgetDirective, descendants: true }], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: OlNgbA11ySortableDataGridDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'table[olNgbA11yGridSortable]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { headers: [{
                type: ContentChildren,
                args: [OlNgbA11ySortableHeaderDirective, { descendants: true }]
            }], gridWidgets: [{
                type: ContentChildren,
                args: [OlGridWidgetDirective, { descendants: true }]
            }], handleKeyDown: [{
                type: HostListener,
                args: ['keydown', ['$event']]
            }] } });

class OlNgbA11ySortableDataGridModule {
}
OlNgbA11ySortableDataGridModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: OlNgbA11ySortableDataGridModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
OlNgbA11ySortableDataGridModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: OlNgbA11ySortableDataGridModule, declarations: [OlNgbA11ySortableDataGridDirective, OlGridWidgetDirective], exports: [OlNgbA11ySortableDataGridDirective, OlGridWidgetDirective] });
OlNgbA11ySortableDataGridModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: OlNgbA11ySortableDataGridModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: OlNgbA11ySortableDataGridModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [OlNgbA11ySortableDataGridDirective, OlGridWidgetDirective],
                    exports: [OlNgbA11ySortableDataGridDirective, OlGridWidgetDirective],
                }]
        }] });

class OlNgbA11yPopoverDirective {
    constructor(popover, elementRef, document) {
        this.popover = popover;
        this.elementRef = elementRef;
        this.document = document;
        this.destroy$ = new Subject();
        this.popoverButton = this.elementRef.nativeElement;
    }
    ngOnInit() {
        // Set the default aria-expanded to false
        this.updateAriaExpandedAttribute(false);
        // On show popover set the attributes
        this.popover.shown.pipe(takeUntil(this.destroy$)).subscribe(() => {
            this.updateAriaExpandedAttribute(true);
            this.removeAttributes();
        });
        this.popover.hidden.pipe(takeUntil(this.destroy$)).subscribe(() => {
            this.updateAriaExpandedAttribute(false);
        });
        this.popoverButton.addEventListener('blur', () => {
            this.popover.close();
        });
    }
    removeAttributes() {
        const popover = this.document.querySelector('ngb-popover-window');
        if (popover) {
            popover.removeAttribute('role');
        }
    }
    updateAriaExpandedAttribute(value) {
        this.popoverButton.setAttribute('aria-expanded', value.toString());
    }
    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
OlNgbA11yPopoverDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: OlNgbA11yPopoverDirective, deps: [{ token: i1.NgbPopover }, { token: i0.ElementRef }, { token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Directive });
OlNgbA11yPopoverDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.4.0", type: OlNgbA11yPopoverDirective, selector: "[ngbPopover]:not([ngbDefault])", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: OlNgbA11yPopoverDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: `[ngbPopover]${OPT_OUT_SELECTOR}`,
                }]
        }], ctorParameters: function () { return [{ type: i1.NgbPopover }, { type: i0.ElementRef }, { type: Document, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }]; } });

const public_declarations = [OlNgbA11yPopoverDirective];
class OlNgbA11yPopoverModule {
}
OlNgbA11yPopoverModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: OlNgbA11yPopoverModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
OlNgbA11yPopoverModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: OlNgbA11yPopoverModule, declarations: [OlNgbA11yPopoverDirective], imports: [NgbPopoverModule], exports: [NgbPopoverModule, OlNgbA11yPopoverDirective] });
OlNgbA11yPopoverModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: OlNgbA11yPopoverModule, imports: [[NgbPopoverModule], NgbPopoverModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: OlNgbA11yPopoverModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [NgbPopoverModule],
                    declarations: [...public_declarations],
                    exports: [NgbPopoverModule, ...public_declarations],
                }]
        }] });

// high-level requirements:
//    - ngbDropdownToggle must be a <button>
//    - Do not provide text for toggle button
//    - All ngbDropdownItems should be generic <button> elements with plain text content
//    - Consumers should place formControlName or ngModel on the same element as this directive
//    - No events are fired outside the CVA pipeline
//    - Focus is handled by directive - focus dropdownTogle when option is selected explicitly (click, spacebar, enter)
class NgbA11yDropSelectDirective {
    constructor(_dropdown, _renderer) {
        this._dropdown = _dropdown;
        this._renderer = _renderer;
        this.searchString = '';
        this._onTouched = noop;
        this._onChanged = noop;
        this._ngDestroy$ = new Subject();
        this._userSelectedOption = false;
        this._confirmKeys = ['Tab', 'Enter', ' '];
        this._avoidKeys = [
            'Control',
            'Alt',
            'Meta',
            'Shift',
            'Backspace',
            'Tab',
            'Enter',
            ' ',
            'Pause',
            'CapsLock',
            'Escape',
            'End',
            'Home',
            'PageUp',
            'PageDown',
            'ArrowRight',
            'ArrowLeft',
            'ArrowUp',
            'ArrowDown',
            'PrintScreen',
            'Insert',
            'Delete',
        ];
    }
    onFocus() {
        this._onTouched();
    }
    // navigate option on search
    onKeyDown(event) {
        // Get the currently focused element
        const focusedElement = document.activeElement;
        const isAvoidKey = this._avoidKeys.includes(event.key);
        if (!isAvoidKey && this.dropdownMenu) {
            //if drop select is not open while search, open drop select
            if (!this.dropdownMenu.isOpen) {
                this._dropdown.open();
            }
            // give Angular time to process the open call, if it was made, before we change focus
            timer(0).subscribe(() => {
                const menuItemArray = this.dropdownMenu?.menuItems.toArray();
                // if there's a focused element, we want to start with its index, which handles the repeated letter
                // case more gracefully than trying to have a search string hysteresis and determine its length, etc
                let searchStartIndex = 0;
                if (focusedElement && menuItemArray) {
                    // find the index of the focused element, then increment so we start the search on the next item
                    searchStartIndex = menuItemArray.findIndex((item) => {
                        return focusedElement === item.elementRef.nativeElement;
                    });
                    searchStartIndex++;
                }
                // get the new search string and perform the search
                const searchString = this._getSearchString(event.key);
                let option;
                if (menuItemArray) {
                    option = this._getOptionBySearchString(menuItemArray, searchString, searchStartIndex);
                }
                // if a match was found, go to it
                if (option) {
                    option.elementRef.nativeElement.focus();
                }
                else {
                    // if no matches, clear the timeout and search string
                    window.clearTimeout(this.searchTimeout);
                    this.searchString = '';
                }
            });
        }
    }
    ngAfterViewInit() {
        // Ensure correct structure
        if (this.dropdownMenu === undefined) {
            console.error('ngbA11yDropMenu found no ngbDropdownMenu');
            return;
        }
        if (this.dropdownToggle === undefined) {
            console.error('ngbA11yDropMenu found no ngbDropdownToggle');
            return;
        }
        if (this.dropdownMenu.menuItems?.length < 1) {
            console.error('ngbA11yDropMenu found no ngbDropdownMenuItems');
            return;
        }
        const menuEl = this.dropdownMenu.nativeElement;
        const toggleEl = this.dropdownToggle.nativeElement;
        // set text of toggle element to ensure it reflects the underlying control's value
        toggleEl.innerHTML = this._getButtonInnerHtml();
        // remove the class that puts ngbDropdown's arrow icon on the button
        this._renderer.removeClass(toggleEl, 'dropdown-toggle');
        // stretch the toggle button to fill its parent
        this._renderer.addClass(toggleEl, 'form-control');
        // these allow the option text and chevron icon to stretch to opposite edges if the button is larger than the text
        this._renderer.addClass(toggleEl, 'd-flex');
        this._renderer.addClass(toggleEl, 'justify-content-between');
        // toggle controls the menu (combobox behavior)
        this._renderer.setAttribute(toggleEl, 'aria-controls', menuEl.id);
        //set roles
        this._renderer.setAttribute(toggleEl, 'role', 'combobox');
        this._renderer.setAttribute(menuEl, 'role', 'listbox');
        // prep the items in the menu
        this._applyMarkupToMenuItems();
        // subscribe to updates so we can reapply if the list changes
        this.dropdownMenu.menuItems.changes.pipe(takeUntil(this._ngDestroy$)).subscribe(() => {
            this._applyMarkupToMenuItems();
        });
        // enable Aura theme to place checkmark on active option
        this._renderer.addClass(menuEl, 'support-active-indicator');
        // enforce menu width as exactly equal to the button width
        this._renderer.addClass(menuEl, 'w-100');
        //add aria attributes to toggle
        this._renderer.setAttribute(toggleEl, 'aria-haspopup', 'listbox');
        // On open, move focus to selected item, or fall back to first item
        this._dropdown.openChange.pipe(takeUntil(this._ngDestroy$)).subscribe((isOpen) => {
            timer(0).subscribe(() => {
                if (isOpen) {
                    // menu is opening, so focus the first item if selection is invalid
                    if (this.selectedOption === undefined) {
                        this.dropdownMenu?.menuItems.first.elementRef.nativeElement?.focus();
                    }
                    else {
                        // selection is valid, so try to focus it
                        this._getSelectedOptionElement()?.elementRef.nativeElement.focus();
                    }
                }
                else {
                    // menu is closing, so focus the toggle button, if user explicitly selected an option
                    if (this._userSelectedOption) {
                        this.dropdownToggle?.nativeElement.focus();
                        this._userSelectedOption = false;
                    }
                }
            });
        });
        // handle keyboard events on the menu, which could trigger selecting an option and possibly focusing
        // the toggle button if Tab was pressed
        fromEvent(menuEl, 'keydown')
            .pipe(
        // only detect keys that are in the confirmKeys array because the rest won't affect selection
        filter((event) => this._confirmKeys.includes(event.key)), takeUntil(this._ngDestroy$))
            .subscribe((event) => {
            this._handleOptionSelectionEvent(event, event.key === 'Tab');
        });
        // handle mouse click events on the menu, which trigger selecting an option if the target was an option
        fromEvent(menuEl, 'click')
            .pipe(takeUntil(this._ngDestroy$))
            .subscribe((event) => {
            this._handleOptionSelectionEvent(event);
        });
    }
    ngOnDestroy() {
        this._ngDestroy$.next();
        this._ngDestroy$.complete();
    }
    writeValue(newValue) {
        if (newValue === null || newValue === undefined) {
            this.selectedOption = undefined;
        }
        else {
            newValue = newValue.trim();
            // update the active indicators
            this._updateActiveIndicators(this.selectedOption, newValue);
            // option is valid, so save it off
            this.selectedOption = newValue;
            // if the views have initialized, attempt to update the selected menu item
            if (this.dropdownToggle) {
                // This takes control of the toggle element's text to enforce select-like behavior
                this.dropdownToggle.nativeElement.innerHTML = this._getButtonInnerHtml();
            }
        }
        // in every case, the selectedOption changed in some way, so notify listeners
        this._onChanged(this.selectedOption);
    }
    registerOnChange(fn) {
        this._onChanged = fn;
    }
    registerOnTouched(fn) {
        this._onTouched = fn;
    }
    _applyMarkupToMenuItems() {
        this.dropdownMenu?.menuItems.forEach((item) => {
            const itemEl = item.elementRef.nativeElement;
            this._renderer.setAttribute(itemEl, 'role', 'option');
            // these classes ensure that the text wraps if an option's text is longer than the menu is wide
            this._renderer.addClass(itemEl, 'text-break');
            this._renderer.addClass(itemEl, 'text-wrap');
            // remove from tab order so tab behavior can match ARIA APG Select-Only Combobox behavior
            this._renderer.setAttribute(itemEl, 'tabIndex', '-1');
            // ensure we add the .active class to the selected item so it displays the indicator
            let attrSelect = 'false';
            if (this.selectedOption === itemEl.textContent?.trim()) {
                this._renderer.addClass(itemEl, 'active');
                attrSelect = 'true';
            }
            this._renderer.setAttribute(itemEl, 'aria-selected', attrSelect);
        });
    }
    _handleOptionSelectionEvent(event, isTabPressEvent = false) {
        // write the value back to the FormControl
        this.writeValue(event.target?.textContent ?? '');
        // this is a bit odd, but we need to know if the user explicitly selected an element, e.g. by
        // pressing Spacebar or Enter, or if they incidentally selected an element by pressing Tab.
        // This is used in the dropdownMenu.openChange handler to optionally set focus on the toggle button
        if (!isTabPressEvent) {
            this._userSelectedOption = true;
        }
        // give Angular a beat to process the writeValue, then close the dropdown
        timer(0).subscribe(() => {
            if (this._dropdown.isOpen()) {
                this._dropdown.close();
            }
        });
    }
    _updateActiveIndicators(oldSelection, newSelection) {
        if (!this.dropdownMenu) {
            return;
        }
        // remove the .active class from the old selection so it doesn't display the indicator
        if (oldSelection) {
            const oldOption = this._findOption(this.dropdownMenu.menuItems.toArray(), oldSelection);
            if (oldOption?.elementRef.nativeElement) {
                this._renderer.removeClass(oldOption.elementRef.nativeElement, 'active');
                this._renderer.setAttribute(oldOption.elementRef.nativeElement, 'aria-selected', 'false');
            }
            else {
                console.error(new Error(`previous value ${oldSelection} for DropSelect FormControl was not in the list of options provided`));
            }
        }
        // add the .active class to the selected item so it displays the indicator
        const newOption = this._findOption(this.dropdownMenu.menuItems.toArray(), newSelection);
        if (newOption?.elementRef.nativeElement) {
            this._renderer.addClass(newOption.elementRef.nativeElement, 'active');
            this._renderer.setAttribute(newOption.elementRef.nativeElement, 'aria-selected', 'true');
        }
        else {
            console.error(new Error(`new selected value ${newSelection} for DropSelect FormControl was not in the list of options provided`));
        }
    }
    _getSearchString(char) {
        // reset typing timeout and start new timeout
        // this allows us to make multiple-letter matches, like a native select
        if (typeof this.searchTimeout === 'number') {
            window.clearTimeout(this.searchTimeout);
        }
        this.searchTimeout = window.setTimeout(() => {
            this.searchString = '';
        }, 500);
        // add most recent letter to saved search string
        this.searchString += char;
        return this.searchString;
    }
    _findOption(options = [], filter) {
        // finds an item in the list by the given string, attempting to match it in its entirety,
        // case-insensitive, from the beginning of the option's text
        return options.find((option) => {
            const optionText = option.elementRef.nativeElement.textContent?.trim();
            if (optionText !== undefined) {
                return optionText.toLowerCase().startsWith(filter.toLowerCase());
            }
            return false;
        });
    }
    _getOptionBySearchString(optionList, searchText, startIndex = 0) {
        if (searchText.length === 0) {
            return undefined;
        }
        // in order to search more easily, restructure the optionList to a new array that starts
        // with the item at startIndex through the end, then the items from the front of the array
        // up to just before startIndex. e.g. with startIndex=2 and optionList=[A,B,C,D,E], this
        // will make orderedOptions=[C,D,E,A,B]
        const orderedOptions = [...optionList.slice(startIndex), ...optionList.slice(0, startIndex)];
        const searchTextChars = searchText.split('');
        // if the same letter is being repeated, cycle through first-letter matches by only searching
        // for the first letter in the search string
        if (searchTextChars.every((letter) => letter === searchTextChars[0])) {
            return this._findOption(orderedOptions, searchText[0]);
        }
        else {
            // different letters were typed, so check for an exact match
            return this._findOption(orderedOptions, searchText);
        }
    }
    _getSelectedOptionElement() {
        if (this.selectedOption === undefined) {
            return undefined;
        }
        return this._findOption(this.dropdownMenu?.menuItems.toArray(), this.selectedOption.trim());
    }
    _getButtonInnerHtml() {
        // wrap the option text in a span that can truncate text, and also include the arrow icon
        return ('<span class="text-truncate">' +
            (this.selectedOption?.trim() ?? 'Select an option') +
            '</span><i class="bi bi-chevron-down" aria-hidden="true"></i>');
    }
}
NgbA11yDropSelectDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: NgbA11yDropSelectDirective, deps: [{ token: i1.NgbDropdown }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Directive });
NgbA11yDropSelectDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.4.0", type: NgbA11yDropSelectDirective, selector: "[ngbDropdown][olNgbA11yDropSelect]", host: { listeners: { "focus": "onFocus()", "keydown": "onKeyDown($event)" } }, providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: forwardRef(() => NgbA11yDropSelectDirective),
        },
    ], queries: [{ propertyName: "dropdownMenu", first: true, predicate: NgbDropdownMenu, descendants: true }, { propertyName: "dropdownToggle", first: true, predicate: NgbDropdownToggle, descendants: true }], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: NgbA11yDropSelectDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[ngbDropdown][olNgbA11yDropSelect]',
                    providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            multi: true,
                            useExisting: forwardRef(() => NgbA11yDropSelectDirective),
                        },
                    ],
                }]
        }], ctorParameters: function () { return [{ type: i1.NgbDropdown }, { type: i0.Renderer2 }]; }, propDecorators: { dropdownMenu: [{
                type: ContentChild,
                args: [NgbDropdownMenu]
            }], dropdownToggle: [{
                type: ContentChild,
                args: [NgbDropdownToggle]
            }], onFocus: [{
                type: HostListener,
                args: ['focus']
            }], onKeyDown: [{
                type: HostListener,
                args: ['keydown', ['$event']]
            }] } });

class NgbA11yDropselectModule {
}
NgbA11yDropselectModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: NgbA11yDropselectModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
NgbA11yDropselectModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: NgbA11yDropselectModule, declarations: [NgbA11yDropSelectDirective], imports: [NgbDropdownModule], exports: [NgbA11yDropSelectDirective] });
NgbA11yDropselectModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: NgbA11yDropselectModule, imports: [[NgbDropdownModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: NgbA11yDropselectModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [NgbA11yDropSelectDirective],
                    exports: [NgbA11yDropSelectDirective],
                    imports: [NgbDropdownModule],
                }]
        }] });

class CharactersRemainingDirective {
    constructor(_renderer2, _hostElement, _liveAnnouncer) {
        this._renderer2 = _renderer2;
        this._hostElement = _hostElement;
        this._liveAnnouncer = _liveAnnouncer;
        this.maxlength = 60;
        this.textContainer = this._renderer2.createElement('p');
        this.remainingTextSmallElement = this._renderer2.createElement('small');
        this.inputNumCharacters = 0;
        this.charactersRemainingText = ' characters remaining';
    }
    onKeyup(event) {
        const inputElement = event.target;
        const value = inputElement.value;
        const charactersRemaining = this.maxlength - value.length;
        let announceLevel = 'polite';
        if (charactersRemaining === 1) {
            this.charactersRemainingText = ' character remaining';
        }
        else {
            this.charactersRemainingText = ' characters remaining';
        }
        const outputText = charactersRemaining + this.charactersRemainingText;
        this.remainingTextSmallElement.innerHTML = outputText;
        if (charactersRemaining === 0) {
            announceLevel = 'assertive';
        }
        this._liveAnnouncer.announce(outputText, announceLevel);
    }
    ngAfterViewInit() {
        this.textContainer.className = 'mb-0';
        this._hostElement.nativeElement.parentElement.appendChild(this.textContainer);
        this.textContainer.appendChild(this.remainingTextSmallElement);
        timer(200)
            .pipe(take(1))
            .subscribe(() => {
            this.remainingTextSmallElement.innerHTML =
                this.maxlength - this._hostElement.nativeElement.value.length + this.charactersRemainingText;
        });
    }
}
CharactersRemainingDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: CharactersRemainingDirective, deps: [{ token: i0.Renderer2 }, { token: i0.ElementRef }, { token: i2$1.LiveAnnouncer }], target: i0.ɵɵFactoryTarget.Directive });
CharactersRemainingDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.4.0", type: CharactersRemainingDirective, selector: "[olNgbCharactersRemaining]", inputs: { maxlength: "maxlength" }, host: { listeners: { "keyup": "onKeyup($event)" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: CharactersRemainingDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[olNgbCharactersRemaining]',
                }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }, { type: i0.ElementRef }, { type: i2$1.LiveAnnouncer }]; }, propDecorators: { maxlength: [{
                type: Input
            }], onKeyup: [{
                type: HostListener,
                args: ['keyup', ['$event']]
            }] } });

class OlNgbCharactersRemainingModule {
}
OlNgbCharactersRemainingModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: OlNgbCharactersRemainingModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
OlNgbCharactersRemainingModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: OlNgbCharactersRemainingModule, declarations: [CharactersRemainingDirective], exports: [CharactersRemainingDirective] });
OlNgbCharactersRemainingModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: OlNgbCharactersRemainingModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: OlNgbCharactersRemainingModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [CharactersRemainingDirective],
                    exports: [CharactersRemainingDirective],
                }]
        }] });

var OptionBehavior;
(function (OptionBehavior) {
    OptionBehavior["Standard"] = "Standard";
    OptionBehavior["NavigatesInSameWindow"] = "NavigatesInSamePage";
    OptionBehavior["NavigatesInNewWindow"] = "NavigatesInNewWindow";
    OptionBehavior["OpensModal"] = "OpensModal";
})(OptionBehavior || (OptionBehavior = {}));

class LhDropMenuComponent {
    constructor() {
        // The options to display in the menu. ALWAYS required in template.
        this.options = [];
        // The tooltip to put on the button, if any
        this.tooltipText = 'Options';
        // The tooltip position
        this.tooltipPlacement = 'auto';
        // Changes the style of the toggle button
        this.btnClass = '';
        // The unique name added to the tooltip for the button and menu. Needed only when tooltipText is not unique on the page.
        // Must be unique on the page
        this.uniqueName = '';
        // Postion of the dropdown menu
        this.menuPlacement = ['bottom-end', 'bottom-start', 'top-end', 'top-start'];
        // Container in which menu is rendered. Default to same container as component.
        this.menuContainer = null;
        /**
         * Optional Prefix for data-automation-id
         */
        this.automationIdPrefix = '';
        // Emitted when a menu option is selected. ALWAYS required in template.
        this.optionSelected = new EventEmitter();
        // Emitted when menu is open
        this.openChange = new EventEmitter();
        this.ariaLabel = '';
    }
    ngOnInit() {
        if (this.options.length === 0) {
            throw new Error('options is a required input!');
        }
        if (!this.optionSelected.observed) {
            throw new Error('optionSelected must be observed!');
        }
        this.ariaLabel = this.tooltipText;
        if (this.uniqueName) {
            this.ariaLabel += ' ' + this.uniqueName;
        }
    }
    menuOptionsHandler(selectedOption, evt) {
        if (evt && this.isNavigationOption(selectedOption)) {
            evt.preventDefault();
        }
        this.optionSelected.emit(selectedOption);
    }
    isNavigationOption(option) {
        return (option.behavior === OptionBehavior.NavigatesInNewWindow ||
            option.behavior === OptionBehavior.NavigatesInSameWindow);
    }
    isModalOption(option) {
        return option.behavior === OptionBehavior.OpensModal;
    }
    getSrOnlyText(option) {
        return {
            [OptionBehavior.NavigatesInNewWindow]: 'opens in a new window',
            [OptionBehavior.NavigatesInSameWindow]: 'opens a page',
            [OptionBehavior.OpensModal]: 'opens in a modal',
            [OptionBehavior.Standard]: '',
        }[option.behavior];
    }
}
LhDropMenuComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: LhDropMenuComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
LhDropMenuComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: LhDropMenuComponent, selector: "lh-drop-menu", inputs: { options: "options", tooltipText: "tooltipText", tooltipPlacement: "tooltipPlacement", btnClass: "btnClass", uniqueName: "uniqueName", menuPlacement: "menuPlacement", menuContainer: "menuContainer", automationIdPrefix: "automationIdPrefix" }, outputs: { optionSelected: "optionSelected", openChange: "openChange" }, ngImport: i0, template: "<div\n  ngbDropdown\n  olNgbA11yDropMenu\n  class=\"d-inline-block position-static\"\n  [placement]=\"menuPlacement\"\n  (openChange)=\"openChange.emit($event)\"\n  [container]=\"menuContainer\"\n>\n  <!-- Extra tooltip announcement behavior is known, low priority, and acceptable for\n    ACR. -->\n  <button\n    type=\"button\"\n    class=\"btn\"\n    [ngClass]=\"btnClass\"\n    ngbDropdownToggle\n    noCaret\n    [attr.aria-label]=\"ariaLabel\"\n    [ngbTooltip]=\"tooltipText\"\n    [placement]=\"tooltipPlacement\"\n    [attr.data-automation-id]=\"automationIdPrefix ? automationIdPrefix + '-lh-drop-menu-button' : null\"\n  >\n    <!-- The icon on each button must be included in the template. -->\n    <ng-content></ng-content>\n  </button>\n\n  <div ngbDropdownMenu [attr.aria-label]=\"tooltipText ? tooltipText : null\">\n    <ng-container *ngFor=\"let option of options; index as i\">\n      <a\n        href=\"#\"\n        *ngIf=\"isNavigationOption(option)\"\n        ngbDropdownItem\n        (click)=\"menuOptionsHandler(option, $event)\"\n        (keydown.space)=\"menuOptionsHandler(option, $event)\"\n        [attr.data-automation-id]=\"\n          automationIdPrefix\n            ? automationIdPrefix +\n              '-lh-drop-menu-option-' +\n              (option.optionAutomationIdPrefix ? option.optionAutomationIdPrefix : i) +\n              '-link'\n            : null\n        \"\n      >\n        {{ option.optionText }}\n        <span class=\"visually-hidden\">{{ getSrOnlyText(option) }}</span>\n      </a>\n      <button\n        *ngIf=\"!isNavigationOption(option)\"\n        ngbDropdownItem\n        (click)=\"menuOptionsHandler(option)\"\n        noCaret\n        [attr.data-automation-id]=\"\n          automationIdPrefix\n            ? automationIdPrefix +\n              '-lh-drop-menu-option-' +\n              (option.optionAutomationIdPrefix ? option.optionAutomationIdPrefix : i) +\n              '-button'\n            : null\n        \"\n      >\n        {{ option.optionText }}\n        <span class=\"visually-hidden\" *ngIf=\"isModalOption(option)\">{{ getSrOnlyText(option) }}</span>\n      </button>\n    </ng-container>\n  </div>\n</div>\n", styles: [""], directives: [{ type: i1.NgbDropdown, selector: "[ngbDropdown]", inputs: ["autoClose", "dropdownClass", "open", "placement", "container", "display"], outputs: ["openChange"], exportAs: ["ngbDropdown"] }, { type: NgbA11yDropMenuDirective, selector: "[ngbDropdown][olNgbA11yDropMenu]", inputs: ["dropMenuId"] }, { type: i1.NgbDropdownToggle, selector: "[ngbDropdownToggle]" }, { type: NgbDropdownToggleNoCaretDirective, selector: "[ngbDropdownToggle][noCaret], [ngbDropdownAnchor][noCaret]" }, { type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i1.NgbTooltip, selector: "[ngbTooltip]", inputs: ["animation", "autoClose", "placement", "triggers", "container", "disableTooltip", "tooltipClass", "openDelay", "closeDelay", "ngbTooltip"], outputs: ["shown", "hidden"], exportAs: ["ngbTooltip"] }, { type: i1.NgbDropdownMenu, selector: "[ngbDropdownMenu]" }, { type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i1.NgbDropdownItem, selector: "[ngbDropdownItem]", inputs: ["disabled"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: LhDropMenuComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lh-drop-menu', template: "<div\n  ngbDropdown\n  olNgbA11yDropMenu\n  class=\"d-inline-block position-static\"\n  [placement]=\"menuPlacement\"\n  (openChange)=\"openChange.emit($event)\"\n  [container]=\"menuContainer\"\n>\n  <!-- Extra tooltip announcement behavior is known, low priority, and acceptable for\n    ACR. -->\n  <button\n    type=\"button\"\n    class=\"btn\"\n    [ngClass]=\"btnClass\"\n    ngbDropdownToggle\n    noCaret\n    [attr.aria-label]=\"ariaLabel\"\n    [ngbTooltip]=\"tooltipText\"\n    [placement]=\"tooltipPlacement\"\n    [attr.data-automation-id]=\"automationIdPrefix ? automationIdPrefix + '-lh-drop-menu-button' : null\"\n  >\n    <!-- The icon on each button must be included in the template. -->\n    <ng-content></ng-content>\n  </button>\n\n  <div ngbDropdownMenu [attr.aria-label]=\"tooltipText ? tooltipText : null\">\n    <ng-container *ngFor=\"let option of options; index as i\">\n      <a\n        href=\"#\"\n        *ngIf=\"isNavigationOption(option)\"\n        ngbDropdownItem\n        (click)=\"menuOptionsHandler(option, $event)\"\n        (keydown.space)=\"menuOptionsHandler(option, $event)\"\n        [attr.data-automation-id]=\"\n          automationIdPrefix\n            ? automationIdPrefix +\n              '-lh-drop-menu-option-' +\n              (option.optionAutomationIdPrefix ? option.optionAutomationIdPrefix : i) +\n              '-link'\n            : null\n        \"\n      >\n        {{ option.optionText }}\n        <span class=\"visually-hidden\">{{ getSrOnlyText(option) }}</span>\n      </a>\n      <button\n        *ngIf=\"!isNavigationOption(option)\"\n        ngbDropdownItem\n        (click)=\"menuOptionsHandler(option)\"\n        noCaret\n        [attr.data-automation-id]=\"\n          automationIdPrefix\n            ? automationIdPrefix +\n              '-lh-drop-menu-option-' +\n              (option.optionAutomationIdPrefix ? option.optionAutomationIdPrefix : i) +\n              '-button'\n            : null\n        \"\n      >\n        {{ option.optionText }}\n        <span class=\"visually-hidden\" *ngIf=\"isModalOption(option)\">{{ getSrOnlyText(option) }}</span>\n      </button>\n    </ng-container>\n  </div>\n</div>\n", styles: [""] }]
        }], propDecorators: { options: [{
                type: Input
            }], tooltipText: [{
                type: Input
            }], tooltipPlacement: [{
                type: Input
            }], btnClass: [{
                type: Input
            }], uniqueName: [{
                type: Input
            }], menuPlacement: [{
                type: Input
            }], menuContainer: [{
                type: Input
            }], automationIdPrefix: [{
                type: Input
            }], optionSelected: [{
                type: Output
            }], openChange: [{
                type: Output
            }] } });

class LhDropMenuModule {
}
LhDropMenuModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: LhDropMenuModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
LhDropMenuModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: LhDropMenuModule, declarations: [LhDropMenuComponent], imports: [CommonModule, NgbTooltipModule, NgbDropdownModule, NgbA11yDropdownModule], exports: [LhDropMenuComponent] });
LhDropMenuModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: LhDropMenuModule, imports: [[CommonModule, NgbTooltipModule, NgbDropdownModule, NgbA11yDropdownModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: LhDropMenuModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, NgbTooltipModule, NgbDropdownModule, NgbA11yDropdownModule],
                    declarations: [LhDropMenuComponent],
                    exports: [LhDropMenuComponent],
                }]
        }] });

class LhKeyboardInstructionsPopoverComponent {
    constructor() {
        // Does grid support editing
        this.supportsEditing = false;
        // Does grid have cell that has multiple widgets in it (like input group with input and datetime-picker)
        this.hasMultiWidgetsCell = false;
        // The tooltip to put on the button, if any
        this.tooltipText = 'Keyboard Instructions';
        // The unique name added to the tooltip for the button and menu. Needed only when tooltipText is not unique on the page.
        // Must be unique on the page
        this.uniqueName = '';
        // Preferred placement of popover and tooltip
        this.placement = 'bottom-end auto';
        this._ngDestroy$ = new Subject();
        this.ariaLabel = '';
    }
    ngOnInit() {
        this.ariaLabel = this.tooltipText;
        if (this.uniqueName) {
            this.ariaLabel += ' ' + this.uniqueName;
        }
    }
    ngAfterViewInit() {
        this.ngbPopover.shown.pipe(takeUntil(this._ngDestroy$)).subscribe(() => {
            if (this.ngbTooltip.isOpen()) {
                this.ngbTooltip.close();
            }
        });
    }
    ngOnDestroy() {
        this._ngDestroy$.next();
        this._ngDestroy$.complete();
    }
}
LhKeyboardInstructionsPopoverComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: LhKeyboardInstructionsPopoverComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
LhKeyboardInstructionsPopoverComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: LhKeyboardInstructionsPopoverComponent, selector: "lh-keyboard-instructions-popover", inputs: { supportsEditing: "supportsEditing", hasMultiWidgetsCell: "hasMultiWidgetsCell", tooltipText: "tooltipText", uniqueName: "uniqueName", placement: "placement" }, viewQueries: [{ propertyName: "ngbTooltip", first: true, predicate: ["ngbTooltipRef"], descendants: true }, { propertyName: "ngbPopover", first: true, predicate: ["ngbPopoverRef"], descendants: true }], ngImport: i0, template: "<button\n  type=\"button\"\n  class=\"btn btn-outline-primary btn-sm border\"\n  [attr.aria-label]=\"ariaLabel\"\n  [ngbTooltip]=\"tooltipText\"\n  #ngbTooltipRef=\"ngbTooltip\"\n  [ngbPopover]=\"instructionsPopoverTpl\"\n  [placement]=\"placement\"\n  #ngbPopoverRef=\"ngbPopover\"\n>\n  <i class=\"bi bi-info-square\"></i>\n</button>\n\n<ng-template #instructionsPopoverTpl>\n  <span class=\"text-primary\">\n    <p>As a keyboard user,</p>\n    <ul>\n      <li>\n        <strong>TAB</strong> moves focus to Row 1 Column 1 cell or last focused cell from above the data grid.\n        User is in <i>grid navigation mode</i>.\n      </li>\n      <li>\n        <strong>RIGHT ARROW, LEFT ARROW, DOWN ARROW</strong>, and <strong>UP ARROW</strong> moves the focus\n        through the data grid's cells regardless of contents when in <i>grid navigation mode</i>.\n      </li>\n      <li *ngIf=\"supportsEditing\">\n        If a cell contains one or more active elements, like an editable field or button,\n        <strong>ENTER</strong> or <strong>F2</strong> switches to <i>grid edit mode</i>.\n      </li>\n      <li *ngIf=\"supportsEditing\">\n        While in <i>grid edit mode</i>,\n        <ul>\n          <li *ngIf=\"hasMultiWidgetsCell\">\n            <strong>TAB</strong> navigates between active elements. The elements' default behaviors are\n            supported.\n          </li>\n          <li>\n            <strong>ENTER</strong> or <strong>F2</strong> saves the inputs and returns to\n            <i>grid navigation mode.</i>\n          </li>\n          <li><strong>ESC</strong> returns to <i>grid navigation mode</i> without saving inputs.</li>\n        </ul>\n      </li>\n      <li>\n        <strong>TAB</strong> from the data grid while in <i>grid navigation mode</i> moves the focus out of\n        the data grid to the next active element.\n      </li>\n    </ul>\n  </span>\n</ng-template>\n", directives: [{ type: i1.NgbTooltip, selector: "[ngbTooltip]", inputs: ["animation", "autoClose", "placement", "triggers", "container", "disableTooltip", "tooltipClass", "openDelay", "closeDelay", "ngbTooltip"], outputs: ["shown", "hidden"], exportAs: ["ngbTooltip"] }, { type: i1.NgbPopover, selector: "[ngbPopover]", inputs: ["animation", "autoClose", "ngbPopover", "popoverTitle", "placement", "triggers", "container", "disablePopover", "popoverClass", "openDelay", "closeDelay"], outputs: ["shown", "hidden"], exportAs: ["ngbPopover"] }, { type: OlNgbA11yPopoverDirective, selector: "[ngbPopover]:not([ngbDefault])" }, { type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: LhKeyboardInstructionsPopoverComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lh-keyboard-instructions-popover', template: "<button\n  type=\"button\"\n  class=\"btn btn-outline-primary btn-sm border\"\n  [attr.aria-label]=\"ariaLabel\"\n  [ngbTooltip]=\"tooltipText\"\n  #ngbTooltipRef=\"ngbTooltip\"\n  [ngbPopover]=\"instructionsPopoverTpl\"\n  [placement]=\"placement\"\n  #ngbPopoverRef=\"ngbPopover\"\n>\n  <i class=\"bi bi-info-square\"></i>\n</button>\n\n<ng-template #instructionsPopoverTpl>\n  <span class=\"text-primary\">\n    <p>As a keyboard user,</p>\n    <ul>\n      <li>\n        <strong>TAB</strong> moves focus to Row 1 Column 1 cell or last focused cell from above the data grid.\n        User is in <i>grid navigation mode</i>.\n      </li>\n      <li>\n        <strong>RIGHT ARROW, LEFT ARROW, DOWN ARROW</strong>, and <strong>UP ARROW</strong> moves the focus\n        through the data grid's cells regardless of contents when in <i>grid navigation mode</i>.\n      </li>\n      <li *ngIf=\"supportsEditing\">\n        If a cell contains one or more active elements, like an editable field or button,\n        <strong>ENTER</strong> or <strong>F2</strong> switches to <i>grid edit mode</i>.\n      </li>\n      <li *ngIf=\"supportsEditing\">\n        While in <i>grid edit mode</i>,\n        <ul>\n          <li *ngIf=\"hasMultiWidgetsCell\">\n            <strong>TAB</strong> navigates between active elements. The elements' default behaviors are\n            supported.\n          </li>\n          <li>\n            <strong>ENTER</strong> or <strong>F2</strong> saves the inputs and returns to\n            <i>grid navigation mode.</i>\n          </li>\n          <li><strong>ESC</strong> returns to <i>grid navigation mode</i> without saving inputs.</li>\n        </ul>\n      </li>\n      <li>\n        <strong>TAB</strong> from the data grid while in <i>grid navigation mode</i> moves the focus out of\n        the data grid to the next active element.\n      </li>\n    </ul>\n  </span>\n</ng-template>\n" }]
        }], propDecorators: { supportsEditing: [{
                type: Input
            }], hasMultiWidgetsCell: [{
                type: Input
            }], tooltipText: [{
                type: Input
            }], uniqueName: [{
                type: Input
            }], placement: [{
                type: Input
            }], ngbTooltip: [{
                type: ViewChild,
                args: ['ngbTooltipRef']
            }], ngbPopover: [{
                type: ViewChild,
                args: ['ngbPopoverRef']
            }] } });

class LhKeyboardInstructionsPopoverModule {
}
LhKeyboardInstructionsPopoverModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: LhKeyboardInstructionsPopoverModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
LhKeyboardInstructionsPopoverModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: LhKeyboardInstructionsPopoverModule, declarations: [LhKeyboardInstructionsPopoverComponent], imports: [CommonModule, NgbTooltipModule, NgbPopoverModule, OlNgbA11yPopoverModule], exports: [LhKeyboardInstructionsPopoverComponent] });
LhKeyboardInstructionsPopoverModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: LhKeyboardInstructionsPopoverModule, imports: [[CommonModule, NgbTooltipModule, NgbPopoverModule, OlNgbA11yPopoverModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: LhKeyboardInstructionsPopoverModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, NgbTooltipModule, NgbPopoverModule, OlNgbA11yPopoverModule],
                    declarations: [LhKeyboardInstructionsPopoverComponent],
                    exports: [LhKeyboardInstructionsPopoverComponent],
                }]
        }] });

class MultiSelectService {
    constructor() {
        this.PREFIX = 'multi-select';
        this.multiSelectId = 1;
        this.id = 1;
        this.uniqueToOriginalIdMap = new Map();
    }
    getMultiSelectId() {
        this.uniqueToOriginalIdMap.set(this.multiSelectId, new Map());
        return this.multiSelectId++;
    }
    hasMultiSelectId(multiSelectId) {
        return this.uniqueToOriginalIdMap.has(multiSelectId);
    }
    getUniqueIdFor(multiSelectId, id) {
        const multiSelectIdMap = this.uniqueToOriginalIdMap.get(multiSelectId);
        if (!multiSelectIdMap) {
            throw `MultiSelectId: ${multiSelectId} is not defined, at multi-select-service`;
        }
        const uniqueId = `${this.PREFIX}-${multiSelectId}-${id}`;
        multiSelectIdMap.set(uniqueId, id);
        return uniqueId;
    }
    removeMultiSelectId(multiSelectId) {
        this.uniqueToOriginalIdMap.delete(multiSelectId);
    }
}
MultiSelectService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: MultiSelectService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
MultiSelectService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: MultiSelectService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: MultiSelectService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

class SelectAutomationIdPipe {
    transform(automationIdPrefix = '', suffix) {
        return automationIdPrefix ? `${automationIdPrefix}-lh-multi-select-${suffix}` : null;
    }
}
SelectAutomationIdPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: SelectAutomationIdPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
SelectAutomationIdPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: SelectAutomationIdPipe, name: "selectAutomationId" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: SelectAutomationIdPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'selectAutomationId',
                }]
        }] });

class MultiSelectComponent {
    constructor(elementRef, multiSelectService, document) {
        this.elementRef = elementRef;
        this.multiSelectService = multiSelectService;
        this.document = document;
        /**
         * Label for the Multi-select list box (interactive element)
         */
        this.label = null;
        /**
         * DOM element ID from where to read the label
         */
        this.labelledBy = null;
        /**
         * attribute indicating this field is required
         */
        this.ariaRequired = false;
        /**
         * Multi-select groups with options
         * @see interface definition for MultiSelectGroup
         */
        this.groups = [];
        /**
         * Multi-select options when groups are not used
         */
        this.options = [];
        /**
         * Optional Prefix for data-automation-id
         */
        this.automationIdPrefix = '';
        /**
         * Optional DOM element ID for aria-describedby on multi-select listbox
         */
        this.describedby = null;
        /**
         * Optional id Prefix when we need to make any change to multi select component
         */
        this.idPrefix = null;
        /**
         * Emits when options are selected/de-selected from the UI. This event emitter will not trigger if you are using the
         * Forms API; in that case use valueChanges(), @see https://angular.io/api/forms/AbstractControl#valueChanges
         */
        this.selected = new EventEmitter();
        this.activeDescendantEl$ = new BehaviorSubject(null);
        this.hasFocus = false;
        this.hasPressedTabKey = false; // whether the TAB key was pressed, used when handling focus on the list box
        this.activeDescendantId$ = this.activeDescendantEl$.pipe(map((activeDescendantEl) => activeDescendantEl?.getAttribute('id') ?? null));
        this.window = this.document.defaultView;
        this.multiSelectId = this.multiSelectService.getMultiSelectId();
    }
    onKeyDownSpace($event) {
        if (!this.hasFocus) {
            return;
        }
        $event.preventDefault();
        const activeDescendantEl = this.activeDescendantEl$?.value;
        if (!activeDescendantEl || activeDescendantEl.ariaDisabled === 'true') {
            return;
        }
        this.scrollToElement(activeDescendantEl);
        this.toggleItemSelectionByEl(activeDescendantEl);
    }
    onKeyDownTab($event) {
        if ($event.altKey || $event.ctrlKey) {
            return;
        }
        this.hasPressedTabKey = true;
        // let the browser fire the focus event
        setTimeout(() => {
            this.hasPressedTabKey = false;
        }, 50);
    }
    writeValue(obj) {
        if (obj === undefined || obj === null || (obj instanceof Array && !obj.length)) {
            this.resetSelected(false);
            return;
        }
        if (this.options.length) {
            const options = obj;
            if (!(options instanceof Array)) {
                throw new Error(`Control expects an array of type MultiSelectOption[] when setting a new value, at multi-select component`);
            }
            this.resetSelected(false);
            options.forEach((o) => {
                const optionInList = this.getMultiSelectOptionById(o.id);
                if (optionInList) {
                    optionInList.selected = true;
                }
            });
            return;
        }
        const groups = obj;
        if (!(groups instanceof Array)) {
            throw new Error(`Control expects an array of type MultiSelectGroup[] when setting a new value, at multi-select component`);
        }
        this.resetSelected(false);
        groups.forEach((group) => {
            const groupInList = this.getMultiSelectGroupByDisplayName(group.displayName);
            if (!groupInList) {
                return;
            }
            group.options.forEach((option) => {
                const optionInList = this.getMultiSelectOptionInGroupById(groupInList, option.id);
                if (optionInList) {
                    optionInList.selected = true;
                }
            });
        });
    }
    registerOnChange(fn) {
        this.notifyFormOnChangedCb = fn;
    }
    registerOnTouched(fn) {
        this.notifyFormOnTouchedCb = fn;
    }
    ngOnChanges(changes) {
        if (changes['groups']?.isFirstChange()) {
            return;
        }
        if (changes['options']?.isFirstChange()) {
            return;
        }
        const hasChangedGroups = typeof changes['groups'] !== 'undefined' &&
            changes['groups'].currentValue !== changes['groups'].previousValue;
        const hasChangedOptions = typeof changes['options'] !== 'undefined' &&
            changes['options'].currentValue !== changes['options'].previousValue;
        if (hasChangedGroups || hasChangedOptions) {
            this.setup();
        }
    }
    ngOnInit() {
        if (this.label === null && this.labelledBy === null) {
            throw new Error(`Either binding 'label' (string) or 'labelledBy' (string) must be provided to MultiSelectComponent, at multi-select component`);
        }
        if (!this.groups?.length && !this.options?.length) {
            throw new Error('Either groups or options must be set to show in the list box, at multi-select-component');
        }
        this.setup();
    }
    setup() {
        this.activeDescendantEl$.next(null);
        this.assertUniqueIds();
        if (this.groups.length) {
            this.groups?.forEach((g, index) => {
                g.uniqueId = this.multiSelectService.getUniqueIdFor(this.multiSelectId, `group-${index}`);
                g.options.forEach((o) => {
                    o.uniqueId = this.multiSelectService.getUniqueIdFor(this.multiSelectId, `group-${index}-option-${o.id}`);
                });
            });
        }
        else {
            this.options.forEach((o) => {
                o.uniqueId = this.multiSelectService.getUniqueIdFor(this.multiSelectId, o.id);
            });
        }
    }
    onMultiSelectArrowDown($event) {
        const activeDescendantEl = this.activeDescendantEl$?.value;
        if (!activeDescendantEl) {
            $event.preventDefault();
            this.focusFirst();
            return;
        }
        const currentOptionIndex = this.indexOf(activeDescendantEl);
        if (currentOptionIndex === -1 || currentOptionIndex === this.optionElementsRef.length - 1) {
            return;
        }
        const nextOptionEl = this.optionElementsRef.get(currentOptionIndex + 1);
        if (!nextOptionEl) {
            return;
        }
        $event.preventDefault();
        this.setActiveDescendant(nextOptionEl.nativeElement);
        this.scrollToElement(nextOptionEl.nativeElement);
    }
    onMultiSelectArrowUp($event) {
        const activeDescendantEl = this.activeDescendantEl$?.value;
        if (!activeDescendantEl) {
            $event.preventDefault();
            this.focusFirst();
            return;
        }
        const currentOptionIndex = this.indexOf(activeDescendantEl);
        if (currentOptionIndex === -1 || currentOptionIndex === 0) {
            return;
        }
        const nextOptionEl = this.optionElementsRef.get(currentOptionIndex - 1);
        if (!nextOptionEl) {
            return;
        }
        $event.preventDefault();
        this.setActiveDescendant(nextOptionEl.nativeElement);
        this.scrollToElement(nextOptionEl.nativeElement);
    }
    focusFirst() {
        const firstOptionEl = this.elementRef.nativeElement.querySelector('li[role="option"]');
        if (firstOptionEl) {
            this.setActiveDescendant(firstOptionEl);
            this.scrollToElement(firstOptionEl);
        }
    }
    indexOf(optionEl) {
        let foundIndex = -1;
        this.optionElementsRef.find((elRef, index) => {
            foundIndex = index;
            return elRef.nativeElement === optionEl;
        });
        return foundIndex;
    }
    onMultiSelectClick() {
        const activeDescendantEl = this.activeDescendantEl$?.value;
        if (activeDescendantEl) {
            this.scrollToElement(activeDescendantEl);
        }
    }
    onOptionClick(event) {
        const targetEl = event?.target?.closest('li');
        if (targetEl?.getAttribute('role') !== 'option') {
            return;
        }
        this.setActiveDescendant(targetEl);
        this.toggleItemSelectionByEl(targetEl);
        event.preventDefault();
        event.stopPropagation();
    }
    onMultiSelectFocus() {
        this.hasFocus = true;
        const activeDescendantEl = this.activeDescendantEl$?.value;
        if (!activeDescendantEl) {
            return;
        }
        if (this.hasPressedTabKey) {
            this.scrollToElement(activeDescendantEl);
        } // else let the click event do the scrolling
    }
    onMultiSelectBlur() {
        this.hasFocus = false;
        // Marks the control as `touched`. A control is touched by blur events that do not change the value.
        if (this.notifyFormOnTouchedCb) {
            this.notifyFormOnTouchedCb();
        }
    }
    /**
     * Set all elements to not selected
     */
    resetSelected(emitSelected = true) {
        this.groups?.forEach((group) => {
            group.options.forEach((option) => {
                option.selected = false;
            });
        });
        this.options?.forEach((option) => (option.selected = false));
        if (emitSelected) {
            this.notifyChanges();
        }
    }
    /**
     * Set all elements to selected.
     *
     * @param emitSelected: boolean - Whether to emit selection event and
     */
    selectAll(emitSelected = true) {
        this.groups?.forEach((group) => {
            group.options.forEach((option) => {
                option.selected = true;
            });
        });
        this.options?.forEach((option) => (option.selected = true));
        if (emitSelected) {
            this.notifyChanges();
        }
    }
    setActiveDescendant(liElement) {
        // The active descendant is the last activated element through mouse or keyboard, no matter of it's selected state
        this.activeDescendantEl$.next(liElement);
    }
    toggleItemSelectionByEl(target) {
        const targetId = target.getAttribute('id');
        if (targetId === null) {
            return;
        }
        const option = this.getMultiSelectOptionByUniqueId(targetId);
        if (!option) {
            return;
        }
        // make eslint happy
        if (typeof option.selected === 'boolean') {
            option.selected = !option.selected;
        }
        else {
            option.selected = true;
        }
        this.notifyChanges();
    }
    notifyChanges() {
        const selected = this.getSelected();
        this.selected.emit(selected);
        if (this.notifyFormOnChangedCb) {
            this.notifyFormOnChangedCb(selected);
        }
    }
    getMultiSelectOptionByUniqueId(uniqueId) {
        let foundOption;
        const findOption = (option) => {
            if (option.uniqueId === uniqueId) {
                foundOption = option;
                return true;
            }
            return false;
        };
        if (this.groups.length > 0) {
            this.groups.map((g) => g.options).find((options) => options.find(findOption));
        }
        else {
            this.options.find(findOption);
        }
        return foundOption;
    }
    getMultiSelectGroupByDisplayName(displayName) {
        return this.groups.find((group) => group.displayName === displayName);
    }
    getMultiSelectOptionInGroupById(group, id) {
        return group.options.find((option) => option.id === id);
    }
    getMultiSelectOptionById(id) {
        return this.options.find((option) => option.id === id);
    }
    /**
     * Scrolls the list box container to make the li[role="option"] target element visible.
     *
     * If the list box container element does not fit completely within the viewport it will scroll the body element
     * as well.
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/clientHeight
     * @param targetEl target element; li[role="option"] element
     */
    scrollToElement(targetEl) {
        // list box bounding client rectangle
        const listBoxBoundingClientRect = this.listBoxElRef.nativeElement.getBoundingClientRect();
        // target element bounding client rectangle
        const elOptionBoundingClientRect = targetEl.getBoundingClientRect();
        // list box element top and bottom coords
        const listBoxTop = listBoxBoundingClientRect.y;
        const listBoxBottom = listBoxBoundingClientRect.y + listBoxBoundingClientRect.height;
        // target element top and bottom coords
        const elTop = elOptionBoundingClientRect.y;
        const elBottom = elTop + elOptionBoundingClientRect.height;
        // height of 1 item within the list box
        const scrollPadding = elBottom - elTop;
        // check if we should scroll the list box container
        const shouldScrollListBoxContainer = !(elTop >= listBoxTop && elBottom <= listBoxBottom);
        if (shouldScrollListBoxContainer) {
            // scroll the list box container (div | ul element)
            let scrollTop = this.listBoxElRef.nativeElement.scrollTop;
            if (elBottom > listBoxBottom) {
                // scroll list box down to see the element
                scrollTop += elBottom - listBoxBottom;
                scrollTop += scrollPadding;
            }
            else if (elTop < listBoxTop) {
                // scroll list box up to see the element
                scrollTop -= listBoxTop - elTop;
                scrollTop -= scrollPadding;
            }
            this.listBoxElRef.nativeElement.scrollTop = scrollTop;
        }
        else {
            // should the browser be scrolled?
            // check if the browser needs to be scrolled, this applies when magnification is used for a11y,
            // i.e. screen size increased from 100% up to 400%, the list box itself might not fit completely in the viewport
            const viewPortBottom = this.document.querySelector('html')?.clientHeight ?? null;
            if (viewPortBottom === null) {
                return;
            }
            if (elBottom > viewPortBottom) {
                // scroll browser down to see the element
                this.window?.scrollBy({
                    top: elBottom - viewPortBottom + scrollPadding,
                });
            }
            else if (elTop < 0) {
                // scroll browser up to see the element
                this.window?.scrollBy({
                    top: elTop - scrollPadding,
                });
            }
        }
    }
    getSelected() {
        if (!this.groups.length) {
            const selectedOptions = this.options
                .filter((o) => o.selected)
                .map((o) => {
                return {
                    id: o.id,
                    displayName: o.displayName,
                };
            });
            return selectedOptions;
        }
        const selectedGroups = this.groups.reduce((selected, group) => {
            const selectedOptions = group.options.filter((o) => o.selected);
            if (!selectedOptions.length) {
                return selected;
            }
            selected.push({
                displayName: group.displayName,
                options: selectedOptions.map((o) => ({
                    id: o.id,
                    displayName: o.displayName,
                })),
            });
            return selected;
        }, []);
        return selectedGroups;
    }
    /**
     * Assert unique IDs within the groups / options. We will generate unique ids for li[role="option"] elements
     * but MultiSelectOption.id(s) can not be repeated either.
     */
    assertUniqueIds() {
        const checkRepeatedIdCb = (options) => {
            const optionIds = new Set();
            options.forEach((o) => {
                if (optionIds.has(o.id)) {
                    throw `Options must not have repeated IDs, the following has a collision: ${o.id}, at multi-select component`;
                }
                optionIds.add(o.id);
            });
        };
        this.groups?.forEach((g) => checkRepeatedIdCb(g.options));
        checkRepeatedIdCb(this.options);
    }
    ngOnDestroy() {
        if (this.multiSelectId) {
            this.multiSelectService.removeMultiSelectId(this.multiSelectId);
        }
    }
}
MultiSelectComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: MultiSelectComponent, deps: [{ token: i0.ElementRef }, { token: MultiSelectService }, { token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Component });
MultiSelectComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: MultiSelectComponent, selector: "lh-multi-select", inputs: { label: "label", labelledBy: "labelledBy", ariaRequired: "ariaRequired", groups: "groups", options: "options", automationIdPrefix: "automationIdPrefix", describedby: "describedby", idPrefix: "idPrefix" }, outputs: { selected: "selected" }, host: { listeners: { "window:keydown.Space": "onKeyDownSpace($event)", "window:keydown.Tab": "onKeyDownTab($event)" } }, providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: MultiSelectComponent,
        },
    ], viewQueries: [{ propertyName: "listBoxElRef", first: true, predicate: ["listBoxElementRef"], descendants: true, read: ElementRef }, { propertyName: "optionElementsRef", predicate: ["optionElementsRef"], descendants: true, read: ElementRef }], usesOnChanges: true, ngImport: i0, template: "<!-- Multi select listbox with groups -->\n<div\n  *ngIf=\"!!groups?.length; else noGroups\"\n  (focus)=\"onMultiSelectFocus()\"\n  (blur)=\"onMultiSelectBlur()\"\n  (click)=\"onMultiSelectClick()\"\n  (keydown.ArrowDown)=\"onMultiSelectArrowDown($event)\"\n  (keydown.ArrowUp)=\"onMultiSelectArrowUp($event)\"\n  [attr.aria-label]=\"label\"\n  [attr.aria-labelledby]=\"labelledBy\"\n  [attr.aria-describedby]=\"describedby\"\n  [attr.aria-activedescendant]=\"activeDescendantId$ | async\"\n  #listBoxElementRef\n  tabindex=\"0\"\n  role=\"listbox\"\n  aria-multiselectable=\"true\"\n  [attr.id]=\"idPrefix ? idPrefix + '-lh-multi-select' : null\"\n>\n  <ul\n    *ngFor=\"let group of groups; index as i\"\n    [attr.aria-labelledby]=\"group.uniqueId\"\n    role=\"group\"\n    [attr.data-automation-id]=\"\n      automationIdPrefix | selectAutomationId: (group.groupAutomationId ? group.groupAutomationId : i)\n    \"\n  >\n    <li [attr.id]=\"group.uniqueId\" role=\"presentation\">\n      {{ group.displayName }}\n    </li>\n    <ng-container\n      *ngTemplateOutlet=\"\n        optionsList;\n        context: {\n          options: group.options,\n          isGroup: true,\n          groupId: group.groupAutomationId ? group.groupAutomationId : i\n        }\n      \"\n    ></ng-container>\n  </ul>\n</div>\n\n<!-- Multi select listbox without groups -->\n<ng-template #noGroups>\n  <ul\n    (focus)=\"onMultiSelectFocus()\"\n    (blur)=\"onMultiSelectBlur()\"\n    (click)=\"onMultiSelectClick()\"\n    (keydown.ArrowDown)=\"onMultiSelectArrowDown($event)\"\n    (keydown.ArrowUp)=\"onMultiSelectArrowUp($event)\"\n    [attr.aria-label]=\"label\"\n    [attr.aria-labelledby]=\"labelledBy\"\n    [attr.aria-required]=\"ariaRequired\"\n    [attr.aria-describedby]=\"describedby\"\n    [attr.aria-activedescendant]=\"activeDescendantId$ | async\"\n    #listBoxElementRef\n    tabindex=\"0\"\n    role=\"listbox\"\n    aria-multiselectable=\"true\"\n    [attr.data-automation-id]=\"automationIdPrefix | selectAutomationId: 'list'\"\n    [attr.id]=\"idPrefix ? idPrefix + '-lh-multi-select' : null\"\n  >\n    <ng-container\n      *ngTemplateOutlet=\"optionsList; context: { options: this.options, isGroup: false, groupId: null }\"\n    ></ng-container>\n  </ul>\n</ng-template>\n\n<!-- Template for options -->\n<ng-template #optionsList let-options=\"options\" let-groupId=\"groupId\">\n  <li\n    *ngFor=\"let option of options; index as i\"\n    (click)=\"onOptionClick($event)\"\n    [attr.id]=\"option?.uniqueId ?? null\"\n    [attr.aria-selected]=\"!!option?.selected\"\n    [attr.aria-disabled]=\"!!option?.disabled\"\n    [ngClass]=\"{\n      focused: (activeDescendantId$ | async) === option.uniqueId,\n      disabled: !!option?.disabled\n    }\"\n    #optionElementsRef\n    role=\"option\"\n    [attr.data-automation-id]=\"\n      automationIdPrefix\n        | selectAutomationId\n          : (groupId\n              ? 'group-' + groupId + '-option-' + (option.itemAutomationId ? option.itemAutomationId : i)\n              : 'option-' + (option.itemAutomationId ? option.itemAutomationId : i))\n    \"\n  >\n    <span>\n      {{ option.displayName }}\n    </span>\n  </li>\n</ng-template>\n", styles: ["@charset \"UTF-8\";[role=listbox]{height:100%;overflow-y:auto;margin:0;padding:0;border:1px solid #aaa;background:white}[role=group]{margin:0;padding:0}[role=group]>[role=presentation]{display:block;margin:0;padding:0 .5em;font-weight:700;line-height:2;background-color:#ccc}[role=option]{display:block;padding:0 1em 0 1.5em;line-height:1.8em;cursor:pointer}[role=option] span{position:relative;line-break:anywhere}[role=option][aria-selected=true] span:before{position:absolute;left:-1em;content:\"\\2713\"}@supports (-moz-appearance: none){[role=option][aria-selected=true] span:before{top:-6px}}[role=option].focused{background:#bde4ff}[role=option].disabled{opacity:.5;pointer-events:none;cursor:not-allowed}\n"], directives: [{ type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }, { type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], pipes: { "async": i2.AsyncPipe, "selectAutomationId": SelectAutomationIdPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: MultiSelectComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lh-multi-select', providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            multi: true,
                            useExisting: MultiSelectComponent,
                        },
                    ], template: "<!-- Multi select listbox with groups -->\n<div\n  *ngIf=\"!!groups?.length; else noGroups\"\n  (focus)=\"onMultiSelectFocus()\"\n  (blur)=\"onMultiSelectBlur()\"\n  (click)=\"onMultiSelectClick()\"\n  (keydown.ArrowDown)=\"onMultiSelectArrowDown($event)\"\n  (keydown.ArrowUp)=\"onMultiSelectArrowUp($event)\"\n  [attr.aria-label]=\"label\"\n  [attr.aria-labelledby]=\"labelledBy\"\n  [attr.aria-describedby]=\"describedby\"\n  [attr.aria-activedescendant]=\"activeDescendantId$ | async\"\n  #listBoxElementRef\n  tabindex=\"0\"\n  role=\"listbox\"\n  aria-multiselectable=\"true\"\n  [attr.id]=\"idPrefix ? idPrefix + '-lh-multi-select' : null\"\n>\n  <ul\n    *ngFor=\"let group of groups; index as i\"\n    [attr.aria-labelledby]=\"group.uniqueId\"\n    role=\"group\"\n    [attr.data-automation-id]=\"\n      automationIdPrefix | selectAutomationId: (group.groupAutomationId ? group.groupAutomationId : i)\n    \"\n  >\n    <li [attr.id]=\"group.uniqueId\" role=\"presentation\">\n      {{ group.displayName }}\n    </li>\n    <ng-container\n      *ngTemplateOutlet=\"\n        optionsList;\n        context: {\n          options: group.options,\n          isGroup: true,\n          groupId: group.groupAutomationId ? group.groupAutomationId : i\n        }\n      \"\n    ></ng-container>\n  </ul>\n</div>\n\n<!-- Multi select listbox without groups -->\n<ng-template #noGroups>\n  <ul\n    (focus)=\"onMultiSelectFocus()\"\n    (blur)=\"onMultiSelectBlur()\"\n    (click)=\"onMultiSelectClick()\"\n    (keydown.ArrowDown)=\"onMultiSelectArrowDown($event)\"\n    (keydown.ArrowUp)=\"onMultiSelectArrowUp($event)\"\n    [attr.aria-label]=\"label\"\n    [attr.aria-labelledby]=\"labelledBy\"\n    [attr.aria-required]=\"ariaRequired\"\n    [attr.aria-describedby]=\"describedby\"\n    [attr.aria-activedescendant]=\"activeDescendantId$ | async\"\n    #listBoxElementRef\n    tabindex=\"0\"\n    role=\"listbox\"\n    aria-multiselectable=\"true\"\n    [attr.data-automation-id]=\"automationIdPrefix | selectAutomationId: 'list'\"\n    [attr.id]=\"idPrefix ? idPrefix + '-lh-multi-select' : null\"\n  >\n    <ng-container\n      *ngTemplateOutlet=\"optionsList; context: { options: this.options, isGroup: false, groupId: null }\"\n    ></ng-container>\n  </ul>\n</ng-template>\n\n<!-- Template for options -->\n<ng-template #optionsList let-options=\"options\" let-groupId=\"groupId\">\n  <li\n    *ngFor=\"let option of options; index as i\"\n    (click)=\"onOptionClick($event)\"\n    [attr.id]=\"option?.uniqueId ?? null\"\n    [attr.aria-selected]=\"!!option?.selected\"\n    [attr.aria-disabled]=\"!!option?.disabled\"\n    [ngClass]=\"{\n      focused: (activeDescendantId$ | async) === option.uniqueId,\n      disabled: !!option?.disabled\n    }\"\n    #optionElementsRef\n    role=\"option\"\n    [attr.data-automation-id]=\"\n      automationIdPrefix\n        | selectAutomationId\n          : (groupId\n              ? 'group-' + groupId + '-option-' + (option.itemAutomationId ? option.itemAutomationId : i)\n              : 'option-' + (option.itemAutomationId ? option.itemAutomationId : i))\n    \"\n  >\n    <span>\n      {{ option.displayName }}\n    </span>\n  </li>\n</ng-template>\n", styles: ["@charset \"UTF-8\";[role=listbox]{height:100%;overflow-y:auto;margin:0;padding:0;border:1px solid #aaa;background:white}[role=group]{margin:0;padding:0}[role=group]>[role=presentation]{display:block;margin:0;padding:0 .5em;font-weight:700;line-height:2;background-color:#ccc}[role=option]{display:block;padding:0 1em 0 1.5em;line-height:1.8em;cursor:pointer}[role=option] span{position:relative;line-break:anywhere}[role=option][aria-selected=true] span:before{position:absolute;left:-1em;content:\"\\2713\"}@supports (-moz-appearance: none){[role=option][aria-selected=true] span:before{top:-6px}}[role=option].focused{background:#bde4ff}[role=option].disabled{opacity:.5;pointer-events:none;cursor:not-allowed}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: MultiSelectService }, { type: Document, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }]; }, propDecorators: { label: [{
                type: Input
            }], labelledBy: [{
                type: Input
            }], ariaRequired: [{
                type: Input
            }], groups: [{
                type: Input
            }], options: [{
                type: Input
            }], automationIdPrefix: [{
                type: Input
            }], describedby: [{
                type: Input
            }], idPrefix: [{
                type: Input
            }], selected: [{
                type: Output
            }], listBoxElRef: [{
                type: ViewChild,
                args: ['listBoxElementRef', { read: ElementRef }]
            }], optionElementsRef: [{
                type: ViewChildren,
                args: ['optionElementsRef', { read: ElementRef }]
            }], onKeyDownSpace: [{
                type: HostListener,
                args: ['window:keydown.Space', ['$event']]
            }], onKeyDownTab: [{
                type: HostListener,
                args: ['window:keydown.Tab', ['$event']]
            }] } });

class LhMultiSelectModule {
}
LhMultiSelectModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: LhMultiSelectModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
LhMultiSelectModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: LhMultiSelectModule, declarations: [MultiSelectComponent, SelectAutomationIdPipe], imports: [CommonModule], exports: [MultiSelectComponent, SelectAutomationIdPipe] });
LhMultiSelectModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: LhMultiSelectModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: LhMultiSelectModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [MultiSelectComponent, SelectAutomationIdPipe],
                    exports: [MultiSelectComponent, SelectAutomationIdPipe],
                }]
        }] });

class ToastService {
    constructor() {
        this.toasts = [];
    }
    show(textOrTpl, options = {}) {
        this.toasts.push({ textOrTpl, options });
    }
    remove(toast) {
        this.toasts = this.toasts.filter((t) => t !== toast);
    }
    clear() {
        this.toasts.splice(0, this.toasts.length);
    }
    showSuccessToast(msg, delay) {
        this.show(msg, {
            classname: 'bg-success text-light',
            delay: delay,
        });
    }
}
ToastService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ToastService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
ToastService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ToastService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ToastService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

class ToastComponent {
    constructor(toastService) {
        this.toastService = toastService;
    }
    isTemplate(template) {
        return template instanceof TemplateRef;
    }
}
ToastComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ToastComponent, deps: [{ token: ToastService }], target: i0.ɵɵFactoryTarget.Component });
ToastComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: ToastComponent, selector: "lh-toast", ngImport: i0, template: "<div role=\"status\">\n  <ngb-toast\n    *ngFor=\"let toast of toastService.toasts\"\n    [class]=\"toast.options.classname\"\n    [autohide]=\"toast.options.autohide ?? true\"\n    [delay]=\"toast.options.delay || 5000\"\n    (hidden)=\"toastService.remove(toast)\"\n    role=\"none\"\n  >\n    <ng-template [ngIf]=\"isTemplate(toast.textOrTpl)\" [ngIfElse]=\"text\">\n      <ng-template [ngTemplateOutlet]=\"toast.textOrTpl\"></ng-template>\n    </ng-template>\n\n    <ng-template #text>\n      <div [innerHtml]=\"toast.textOrTpl\"></div>\n    </ng-template>\n  </ngb-toast>\n</div>\n", components: [{ type: i1.NgbToast, selector: "ngb-toast", inputs: ["animation", "delay", "autohide", "header"], outputs: ["shown", "hidden"], exportAs: ["ngbToast"] }], directives: [{ type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ToastComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lh-toast', template: "<div role=\"status\">\n  <ngb-toast\n    *ngFor=\"let toast of toastService.toasts\"\n    [class]=\"toast.options.classname\"\n    [autohide]=\"toast.options.autohide ?? true\"\n    [delay]=\"toast.options.delay || 5000\"\n    (hidden)=\"toastService.remove(toast)\"\n    role=\"none\"\n  >\n    <ng-template [ngIf]=\"isTemplate(toast.textOrTpl)\" [ngIfElse]=\"text\">\n      <ng-template [ngTemplateOutlet]=\"toast.textOrTpl\"></ng-template>\n    </ng-template>\n\n    <ng-template #text>\n      <div [innerHtml]=\"toast.textOrTpl\"></div>\n    </ng-template>\n  </ngb-toast>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: ToastService }]; } });

class LhToastModule {
}
LhToastModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: LhToastModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
LhToastModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: LhToastModule, declarations: [ToastComponent], imports: [NgbToastModule, CommonModule], exports: [ToastComponent] });
LhToastModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: LhToastModule, providers: [ToastService], imports: [[NgbToastModule, CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: LhToastModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [ToastComponent],
                    imports: [NgbToastModule, CommonModule],
                    exports: [ToastComponent],
                    providers: [ToastService],
                }]
        }] });

class SearchBarComponent {
    constructor(liveAnnouncer) {
        this.liveAnnouncer = liveAnnouncer;
        /**
         * Search input field aria label.
         */
        this.searchInputAriaLabel = 'Search Input';
        /**
         * Clear search button aria label.
         */
        this.clearSearchAriaLabel = 'Clear Search';
        /**
         * Search button aria label.
         */
        this.searchAriaLabel = 'Search';
        /**
         * Search results; host component is responsible for conducting the search and feeding the result numbers
         */
        this.searchResults = {
            resultCount: 0,
            collectionSize: 0,
        };
        /**
         * Whether to show the result count or not, "Displaying X of X results". Can be used to control its visibility
         * when a new search executed; default value is false.
         */
        this.showResultCount = false;
        /**
         * Optional Prefix for data-automation-id
         */
        this.automationIdPrefix = '';
        /**
         * Search query, can be optionally set to a default value using a binding
         */
        this.query = '';
        /**
         * Search placeholder to add an A11y compliant placeholder to the input; default value is false
         */
        this.placeholderInput = false;
        /**
         * DOM element ID from where to read the label for the landmark
         */
        this.searchLandmarkLabelledBy = null;
        /**
         * DOM element ID from where to read the description
         */
        this.searchInputDescribedBy = null;
        /**
         * EventEmitter to be used for being notified when query changes
         */
        this.changed = new EventEmitter();
        this.ANNOUNCE_DURATION = 500;
    }
    ngOnChanges(changes) {
        const searchResults = changes['searchResults'];
        const currentValue = searchResults?.currentValue;
        if (searchResults &&
            !searchResults.isFirstChange() &&
            currentValue.collectionSize &&
            currentValue.collectionSize > 0) {
            this.announceResults();
        }
    }
    clearSearch() {
        this.query = '';
        this.changed.emit(undefined);
        this.searchInput.nativeElement.focus();
    }
    focusOnInput() {
        if (this.placeholderInput) {
            this.searchInput.nativeElement.focus();
        }
    }
    announceResults() {
        // Added timer to resolve NVDA specific issue when user clears out search, NVDA expects a little more time to come up with the announcements
        timer(0).subscribe(() => {
            void this.liveAnnouncer.announce(`Displaying ${this.searchResults.resultCount} of ${this.searchResults.collectionSize} result${this.searchResults.resultCount === 1 ? '' : 's'}.`, 'polite', this.ANNOUNCE_DURATION);
        });
    }
}
SearchBarComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: SearchBarComponent, deps: [{ token: i2$1.LiveAnnouncer }], target: i0.ɵɵFactoryTarget.Component });
SearchBarComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: SearchBarComponent, selector: "lh-search-bar", inputs: { searchInputAriaLabel: "searchInputAriaLabel", clearSearchAriaLabel: "clearSearchAriaLabel", searchAriaLabel: "searchAriaLabel", searchResults: "searchResults", showResultCount: "showResultCount", automationIdPrefix: "automationIdPrefix", query: "query", placeholderInput: "placeholderInput", searchLandmarkLabelledBy: "searchLandmarkLabelledBy", searchInputDescribedBy: "searchInputDescribedBy" }, outputs: { changed: "changed" }, viewQueries: [{ propertyName: "searchInput", first: true, predicate: ["searchInput"], descendants: true, read: ElementRef }], usesOnChanges: true, ngImport: i0, template: "<div\n  [ngClass]=\"{ 'input-group': true, 'form-label-as-placeholder': placeholderInput }\"\n  role=\"search\"\n  [attr.aria-labelledby]=\"searchLandmarkLabelledBy\"\n>\n  <input\n    #searchInput\n    type=\"text\"\n    class=\"form-control\"\n    [attr.data-automation-id]=\"automationIdPrefix ? automationIdPrefix + '-lh-search-input' : null\"\n    [(ngModel)]=\"query\"\n    [attr.aria-label]=\"searchInputAriaLabel\"\n    [attr.aria-describedby]=\"searchInputDescribedBy\"\n    [placeholder]=\"placeholderInput ? searchInputAriaLabel : ''\"\n    (keydown.enter)=\"changed.emit(query)\"\n  />\n\n  <label *ngIf=\"placeholderInput\" (click)=\"focusOnInput()\" aria-hidden=\"true\">{{\n    searchInputAriaLabel\n  }}</label>\n\n  <!-- Clear search -->\n  <button\n    *ngIf=\"query.length\"\n    type=\"button\"\n    class=\"btn btn-outline-primary clear-search-btn\"\n    [attr.aria-label]=\"clearSearchAriaLabel\"\n    ngbTooltip=\"Clear Search\"\n    [attr.data-automation-id]=\"automationIdPrefix ? automationIdPrefix + '-lh-search-clear-search-btn' : null\"\n    (click)=\"clearSearch()\"\n  >\n    <i class=\"bi bi-x-lg\"></i>\n  </button>\n\n  <!-- Search -->\n  <button\n    class=\"btn btn-outline-primary search-btn\"\n    type=\"button\"\n    [attr.aria-label]=\"searchAriaLabel\"\n    ngbTooltip=\"Search\"\n    container=\"body\"\n    [attr.data-automation-id]=\"\n      automationIdPrefix ? automationIdPrefix + '-lh-search-submit-search-btn' : null\n    \"\n    (click)=\"changed.emit(query)\"\n  >\n    <i class=\"bi bi-search\"></i>\n  </button>\n</div>\n\n<div\n  class=\"results\"\n  [attr.data-automation-id]=\"automationIdPrefix ? automationIdPrefix + '-lh-search-results' : null\"\n  [ngClass]=\"{\n    'results-hidden': !showResultCount || !searchResults.collectionSize\n  }\"\n>\n  <span *ngIf=\"showResultCount && searchResults.collectionSize && searchResults.collectionSize > 0\">\n    Displaying {{ searchResults.resultCount }} of {{ searchResults.collectionSize }} result{{\n      searchResults.collectionSize === 1 ? '' : 's'\n    }}.\n  </span>\n</div>\n", directives: [{ type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i3.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i1.NgbTooltip, selector: "[ngbTooltip]", inputs: ["animation", "autoClose", "placement", "triggers", "container", "disableTooltip", "tooltipClass", "openDelay", "closeDelay", "ngbTooltip"], outputs: ["shown", "hidden"], exportAs: ["ngbTooltip"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: SearchBarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lh-search-bar', template: "<div\n  [ngClass]=\"{ 'input-group': true, 'form-label-as-placeholder': placeholderInput }\"\n  role=\"search\"\n  [attr.aria-labelledby]=\"searchLandmarkLabelledBy\"\n>\n  <input\n    #searchInput\n    type=\"text\"\n    class=\"form-control\"\n    [attr.data-automation-id]=\"automationIdPrefix ? automationIdPrefix + '-lh-search-input' : null\"\n    [(ngModel)]=\"query\"\n    [attr.aria-label]=\"searchInputAriaLabel\"\n    [attr.aria-describedby]=\"searchInputDescribedBy\"\n    [placeholder]=\"placeholderInput ? searchInputAriaLabel : ''\"\n    (keydown.enter)=\"changed.emit(query)\"\n  />\n\n  <label *ngIf=\"placeholderInput\" (click)=\"focusOnInput()\" aria-hidden=\"true\">{{\n    searchInputAriaLabel\n  }}</label>\n\n  <!-- Clear search -->\n  <button\n    *ngIf=\"query.length\"\n    type=\"button\"\n    class=\"btn btn-outline-primary clear-search-btn\"\n    [attr.aria-label]=\"clearSearchAriaLabel\"\n    ngbTooltip=\"Clear Search\"\n    [attr.data-automation-id]=\"automationIdPrefix ? automationIdPrefix + '-lh-search-clear-search-btn' : null\"\n    (click)=\"clearSearch()\"\n  >\n    <i class=\"bi bi-x-lg\"></i>\n  </button>\n\n  <!-- Search -->\n  <button\n    class=\"btn btn-outline-primary search-btn\"\n    type=\"button\"\n    [attr.aria-label]=\"searchAriaLabel\"\n    ngbTooltip=\"Search\"\n    container=\"body\"\n    [attr.data-automation-id]=\"\n      automationIdPrefix ? automationIdPrefix + '-lh-search-submit-search-btn' : null\n    \"\n    (click)=\"changed.emit(query)\"\n  >\n    <i class=\"bi bi-search\"></i>\n  </button>\n</div>\n\n<div\n  class=\"results\"\n  [attr.data-automation-id]=\"automationIdPrefix ? automationIdPrefix + '-lh-search-results' : null\"\n  [ngClass]=\"{\n    'results-hidden': !showResultCount || !searchResults.collectionSize\n  }\"\n>\n  <span *ngIf=\"showResultCount && searchResults.collectionSize && searchResults.collectionSize > 0\">\n    Displaying {{ searchResults.resultCount }} of {{ searchResults.collectionSize }} result{{\n      searchResults.collectionSize === 1 ? '' : 's'\n    }}.\n  </span>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: i2$1.LiveAnnouncer }]; }, propDecorators: { searchInputAriaLabel: [{
                type: Input
            }], clearSearchAriaLabel: [{
                type: Input
            }], searchAriaLabel: [{
                type: Input
            }], searchResults: [{
                type: Input
            }], showResultCount: [{
                type: Input
            }], automationIdPrefix: [{
                type: Input
            }], query: [{
                type: Input
            }], placeholderInput: [{
                type: Input
            }], searchLandmarkLabelledBy: [{
                type: Input
            }], searchInputDescribedBy: [{
                type: Input
            }], changed: [{
                type: Output
            }], searchInput: [{
                type: ViewChild,
                args: ['searchInput', { read: ElementRef }]
            }] } });

class SearchInputModule {
}
SearchInputModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: SearchInputModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SearchInputModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: SearchInputModule, declarations: [SearchBarComponent], imports: [CommonModule, FormsModule, NgbTooltipModule], exports: [SearchBarComponent] });
SearchInputModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: SearchInputModule, imports: [[CommonModule, FormsModule, NgbTooltipModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: SearchInputModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [SearchBarComponent],
                    imports: [CommonModule, FormsModule, NgbTooltipModule],
                    exports: [SearchBarComponent],
                }]
        }] });

class LhSpinnerComponent {
    constructor(liveAnnouncer) {
        this.liveAnnouncer = liveAnnouncer;
        this.isOpen = false;
        this.loadingMessage = 'Loading';
        this.automationIdPrefix = '';
        this.captureFocus = true;
        this.clickSpinner = new EventEmitter();
        this.annouceInterval = 10000;
        this.announceInterval$ = interval(this.annouceInterval);
        this.intervalSubscription = new Subscription();
        this.onDestroy$ = new Subject();
    }
    announcePageLoading() {
        this.intervalSubscription = this.announceInterval$.pipe(takeUntil(this.onDestroy$)).subscribe(() => {
            void this.liveAnnouncer.announce(this.loadingMessage, 'assertive');
        });
    }
    ngOnChanges(changes) {
        if (changes['isOpen']) {
            if (changes['isOpen'].currentValue) {
                this.announcePageLoading();
            }
            else {
                this.liveAnnouncer.clear();
                this.intervalSubscription.unsubscribe();
            }
        }
    }
    ngOnDestroy() {
        this.onDestroy$.next();
        this.onDestroy$.complete();
        this.intervalSubscription.unsubscribe();
    }
}
LhSpinnerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: LhSpinnerComponent, deps: [{ token: i2$1.LiveAnnouncer }], target: i0.ɵɵFactoryTarget.Component });
LhSpinnerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: LhSpinnerComponent, selector: "lh-spinner", inputs: { isOpen: "isOpen", loadingMessage: "loadingMessage", automationIdPrefix: "automationIdPrefix", captureFocus: "captureFocus" }, outputs: { clickSpinner: "clickSpinner" }, usesOnChanges: true, ngImport: i0, template: "<div class=\"spinner-with-backdrop fade show\" *ngIf=\"isOpen\" (click)=\"clickSpinner.emit()\">\n  <div\n    class=\"spinner-border text-primary\"\n    role=\"status\"\n    [cdkTrapFocus]=\"captureFocus\"\n    [cdkTrapFocusAutoCapture]=\"captureFocus\"\n    tabindex=\"0\"\n    (click)=\"clickSpinner.emit()\"\n    [attr.data-automation-id]=\"automationIdPrefix ? automationIdPrefix + '-lh-spinner' : null\"\n  >\n    <span class=\"visually-hidden\">{{ loadingMessage }}</span>\n  </div>\n</div>\n", styles: [".spinner-with-backdrop{position:fixed;display:flex;top:0;left:0;z-index:1055;width:100vw;height:100vh;background-color:var(--bs-white);align-items:center;justify-content:center}.spinner-with-backdrop.fade{opacity:0}.spinner-with-backdrop.show{opacity:.8}\n"], directives: [{ type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2$1.CdkTrapFocus, selector: "[cdkTrapFocus]", inputs: ["cdkTrapFocus", "cdkTrapFocusAutoCapture"], exportAs: ["cdkTrapFocus"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: LhSpinnerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lh-spinner', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"spinner-with-backdrop fade show\" *ngIf=\"isOpen\" (click)=\"clickSpinner.emit()\">\n  <div\n    class=\"spinner-border text-primary\"\n    role=\"status\"\n    [cdkTrapFocus]=\"captureFocus\"\n    [cdkTrapFocusAutoCapture]=\"captureFocus\"\n    tabindex=\"0\"\n    (click)=\"clickSpinner.emit()\"\n    [attr.data-automation-id]=\"automationIdPrefix ? automationIdPrefix + '-lh-spinner' : null\"\n  >\n    <span class=\"visually-hidden\">{{ loadingMessage }}</span>\n  </div>\n</div>\n", styles: [".spinner-with-backdrop{position:fixed;display:flex;top:0;left:0;z-index:1055;width:100vw;height:100vh;background-color:var(--bs-white);align-items:center;justify-content:center}.spinner-with-backdrop.fade{opacity:0}.spinner-with-backdrop.show{opacity:.8}\n"] }]
        }], ctorParameters: function () { return [{ type: i2$1.LiveAnnouncer }]; }, propDecorators: { isOpen: [{
                type: Input
            }], loadingMessage: [{
                type: Input
            }], automationIdPrefix: [{
                type: Input
            }], captureFocus: [{
                type: Input
            }], clickSpinner: [{
                type: Output
            }] } });

class LhSpinnerModule {
}
LhSpinnerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: LhSpinnerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
LhSpinnerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: LhSpinnerModule, declarations: [LhSpinnerComponent], imports: [CommonModule, A11yModule], exports: [LhSpinnerComponent] });
LhSpinnerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: LhSpinnerModule, imports: [[CommonModule, A11yModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: LhSpinnerModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, A11yModule],
                    declarations: [LhSpinnerComponent],
                    exports: [LhSpinnerComponent],
                }]
        }] });

class DateTimeModel {
    constructor(dateTimeModel) {
        const today = new Date();
        this.year = dateTimeModel?.year ?? today.getFullYear();
        this.month = dateTimeModel?.month ?? today.getMonth() + 1;
        this.day = dateTimeModel?.day ?? today.getDate();
        this.hour = dateTimeModel?.hour || 0;
        this.minute = dateTimeModel?.minute || 0;
        this.second = dateTimeModel?.second || 0;
    }
    static fromDateTimeString(dateTimeString) {
        return DateTimeModel.fromDate(new Date(dateTimeString));
    }
    static fromDate(date) {
        if (!(date instanceof Date) || isNaN(date.getTime())) {
            throw new Error('fromDate expects a Date instance with a valid date set');
        }
        return new DateTimeModel({
            year: date.getFullYear(),
            month: date.getMonth() + 1,
            day: date.getDate(),
            hour: date.getHours(),
            minute: date.getMinutes(),
            second: date.getSeconds(),
        });
    }
    static fromDateModel(dateModel) {
        return DateTimeModel.fromNgbDateStruct(dateModel);
    }
    static fromNgbDateStruct(ngbDateStruct) {
        return new DateTimeModel({
            year: ngbDateStruct.year,
            month: ngbDateStruct.month,
            day: ngbDateStruct.day,
            hour: 0,
            minute: 0,
            second: 0,
        });
    }
    toDate() {
        return new Date(this.year, this.month - 1, this.day, this.hour || 0, this.minute || 0, this.second || 0);
    }
}

class DatePickerService {
    constructor(_datePipe, locale) {
        this._datePipe = _datePipe;
        this.locale = locale;
        this.DEFAULT_DATE_TIME_FORMAT = 'M/d/yyyy hh:mm a';
        this.DEFAULT_LOCALE_ID = 'en-US';
        this.messageForPMtoAM = 'PM to AM';
    }
    toStr(dateTimeModel, dateFormat = this.DEFAULT_DATE_TIME_FORMAT, timeZone) {
        let date = '';
        if (dateTimeModel.month) {
            date = `${dateTimeModel.month}/${dateTimeModel.day}/${dateTimeModel.year}`;
        }
        if (dateTimeModel.hour || dateTimeModel.hour === 0) {
            date += ` ${dateTimeModel.hour}:${dateTimeModel.minute}`;
        }
        return this._datePipe.transform(date, dateFormat, timeZone, this.locale || this.DEFAULT_LOCALE_ID);
    }
    /**
     * Will validate a date time;
     * if isTimeRequired is false then if time is not supplied value will still be considered valid, i.e. '6/8/2024'
     *
     * Other valid values: '1/1/2025 10:12 AM', '3/2/2022 1:13 PM'
     *
     * Invalid: '10:12 AM', 'not-valid', etc (when date is not supplied it will return as invalid)
     *
     * @param dateToValidate DateTimeModel | string otherwise will return invalid
     * @param checkSeconds boolean
     * @param isTimeRequired boolean if true return invalid is if time is not supplied
     * @return boolean
     */
    isValidDateTime(dateToValidate, checkSeconds = true, isTimeRequired = false) {
        if (!dateToValidate || (typeof dateToValidate !== 'string' && typeof dateToValidate !== 'object')) {
            return false;
        }
        if (typeof dateToValidate === 'string') {
            try {
                DateTimeModel.fromDateTimeString(dateToValidate);
            }
            catch (e) {
                return false;
            }
            if (isTimeRequired) {
                const time = dateToValidate.split(' ')[1]?.trim();
                const timeRegex = /(0?[1-9]|1[0-2]):[0-5][0-9]/g;
                const meridiem = dateToValidate.split(' ')[2]?.trim().toLowerCase();
                if (!time || !meridiem) {
                    return false;
                }
                if (!meridiem.includes('am') && !meridiem.includes('pm')) {
                    return false;
                }
                if (!time.match(timeRegex)) {
                    return false;
                }
            }
            return true;
        }
        const date = dateToValidate;
        if (!this._isValidDate(date)) {
            return false;
        }
        if (date.hour && !this.isValidTime(date, checkSeconds)) {
            return false;
        }
        return true;
    }
    /**
     * Will either return the injected LOCALE_ID provided by a parent module or use the DatePickerService
     * default locale id (en-US)
     */
    getLocaleId() {
        return this.locale || this.DEFAULT_LOCALE_ID;
    }
    /**
     * Validate date time, @see isValidDateTime()
     *
     * @return ValidatorFn can be used as regular validator for any angular AbstractControl
     */
    dateTimeValidator(checkSeconds = false) {
        return (control) => {
            return this.isValidDateTime(control.value, checkSeconds)
                ? null
                : {
                    datepicker: control.value,
                };
        };
    }
    /**
     * Validate date time, @see isValidDateTime()
     * Time is mandatory for it to be valid
     *
     * @return ValidatorFn can be used as regular validator for any angular AbstractControl
     */
    dateTimeStrictValidator(checkSeconds = false) {
        return (control) => {
            return this.isValidDateTime(control.value, checkSeconds, true)
                ? null
                : {
                    datepicker: control.value,
                };
        };
    }
    /**
     * Validate time only
     *
     * @return ValidatorFn can be used as regular validator for any angular AbstractControl
     */
    timeValidator(checkSeconds = false) {
        return (control) => {
            return this.isValidTime(control.value, checkSeconds)
                ? null
                : {
                    datepicker: control.value,
                };
        };
    }
    generateUniqueId() {
        return `${v4().substring(0, 4)}`;
    }
    _isNumber(value) {
        return !isNaN(value);
    }
    isValidTime(time, checkSeconds = true) {
        if (!time) {
            return false;
        }
        if (!this._isNumber(time.hour) || !this._isNumber(time.minute)) {
            return false;
        }
        const timeModel = time;
        if (timeModel.hour < 0 || timeModel.hour > 23) {
            return false;
        }
        if (timeModel.minute < 0 || timeModel.minute > 59) {
            return false;
        }
        if (checkSeconds) {
            return this._isNumber(timeModel.second) && timeModel.second >= 0 && timeModel.second <= 59;
        }
        return true;
    }
    _isValidDate(model) {
        const modelToValidate = model;
        // Subtracting 1, as month is month index, not month
        const date = new Date(modelToValidate.year, modelToValidate.month - 1, modelToValidate.day);
        return !isNaN(date.getTime());
    }
    convertTimeFormatToAnnouncement(inputTime, meridiem) {
        if (!inputTime) {
            return this.messageForPMtoAM;
        }
        const { hour, minute } = inputTime;
        const hoursIn12Format = hour % 12 || 12; // Handle midnight (0 hours)
        const formattedMinutes = minute.toString().padStart(2, '0');
        if (meridiem === '' || meridiem === undefined) {
            meridiem = hour >= 12 ? 'pm' : 'am';
        }
        const hourString = isNaN(hour) ? 'hours not set' : hoursIn12Format;
        const minuteString = isNaN(minute) ? 'minutes not set' : formattedMinutes;
        const formattedTime = `${hourString}:${minuteString} ${meridiem}`;
        return formattedTime;
    }
}
DatePickerService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DatePickerService, deps: [{ token: i2.DatePipe }, { token: LOCALE_ID, optional: true }], target: i0.ɵɵFactoryTarget.Injectable });
DatePickerService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DatePickerService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DatePickerService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i2.DatePipe }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [LOCALE_ID]
                }, {
                    type: Optional
                }] }]; } });

class DatePickerComponent {
    constructor(i18n, _elementRef, _renderer, _datePickerService, _injector, _liveAnnouncer, _datePipe, _renderer2, _ngZone) {
        this.i18n = i18n;
        this._elementRef = _elementRef;
        this._renderer = _renderer;
        this._datePickerService = _datePickerService;
        this._injector = _injector;
        this._liveAnnouncer = _liveAnnouncer;
        this._datePipe = _datePipe;
        this._renderer2 = _renderer2;
        this._ngZone = _ngZone;
        /**
         * Wrap NgbDatepicker dateSelect event
         */
        this.dateSelect = new EventEmitter();
        this.uniqueId = `datepicker-${this._datePickerService.generateUniqueId()}`;
        this._onTouched = noop;
        this._onChanged = noop;
        this._ngDestroy$ = new Subject();
        this._setupNgb();
        this.ngbDatePickerCtrl.valueChanges
            .pipe(takeUntil(this._ngDestroy$))
            .subscribe((DateModel) => {
            return this._onChanged(DateModel);
        });
        this._isStable = this._ngZone.onStable.pipe(take(1), takeUntil(this._ngDestroy$));
    }
    _setupNgb() {
        const today = new Date();
        const model = {
            year: today.getFullYear(),
            month: today.getMonth() + 1,
            day: today.getDate(),
        };
        this.ngbDatePickerCtrl = new FormControl(model, [
            Validators.required,
            this._datePickerService.dateTimeValidator(),
        ]);
        this.navigatedTo = { ...model };
    }
    ngOnInit() {
        try {
            this.ngControl = this._injector.get(NgControl);
        }
        catch (e) {
            throw new Error('Datepicker expects an instance of NgControl injected; did you set formControlName / formControl on the date picker template?');
        }
    }
    navigateToPrevMonth() {
        const { state, calendar } = this._ngbDatePicker;
        const date = calendar.getPrev(state.firstDate, 'm', 1);
        this._navigateToMonth(date);
    }
    navigateToNextMonth() {
        const { state, calendar } = this._ngbDatePicker;
        const date = calendar.getNext(state.firstDate, 'm', 1);
        this._navigateToMonth(date);
    }
    writeValue(value) {
        this.ngbDatePickerCtrl.setValue(value);
    }
    registerOnChange(fn) {
        this._onChanged = fn;
    }
    registerOnTouched(fn) {
        this._onTouched = fn;
    }
    setDisabledState(isDisabled) {
        isDisabled ? this.ngbDatePickerCtrl.disable() : this.ngbDatePickerCtrl.enable();
    }
    onDatepickerNavigate(_event) {
        this.navigatedTo.year = _event.next.year;
        this.navigatedTo.month = _event.next.month;
        this._checkA11y();
    }
    /* istanbul ignore next */
    onNgbDatePickerFocusIn() {
        this._onTouched();
    }
    /**
     * Wrapper to NgbDatepicker original method to allow it's usage without breaking encapsulation.
     *
     * @param date NgbDateStruct
     */
    /* istanbul ignore next */
    focusDate(date) {
        this._ngbDatePicker.focusDate(date);
    }
    /**
     * This method implements a hack to suspend ngb-datepicker focus while running a callback. It restores the original
     * focus function right away after executing our code.
     *
     * Why did we have to implement this hack?
     *
     * If you take a look at:
     * @see https://github.com/ng-bootstrap/ng-bootstrap/blob/12.1.2/src/datepicker/datepicker.ts#L366
     *
     * you will notice this code is executed every time that we navigate between months. After debugging ng-bootstrap's
     * component for a while we could not find another way to disable the focusing but this one.
     *
     * If you want to see the original behavior just comment out the code in this method and check how the focus is removed
     * from the navigating arrows when you move between months.
     */
    _suspendNgbDatepickerFocus(callbackFn) {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        const focusFn = this._ngbDatePicker.focus;
        this._ngbDatePicker.focus = noop;
        callbackFn();
        this._ngbDatePicker.focus = focusFn;
    }
    _checkA11y() {
        this._isStable.subscribe(() => {
            this._checkAriaLabelForCurrentDate();
            this._checkAriaSelectedAttributeForDaysInMonth();
        });
    }
    /**
     * Checks whether it has to remove / append the string 'Today' to the current date in the calendar.
     *
     * For the case where the user is standing on the current month, the date corresponding to the current date will
     * get the 'Today' string appended to it's aria-label attribute. If navigation occurs to a different month, it has
     * to be removed; as ng-bootstrap's re-uses the DOM elements for the calendar (those with .ngb-dp-day class).
     */
    _checkAriaLabelForCurrentDate() {
        const ngbDpTodayEl = this._elementRef.nativeElement.querySelector('.ngb-dp-today');
        if (!ngbDpTodayEl) {
            return;
        }
        if (ngbDpTodayEl.getAttribute('aria-label')?.includes('Today')) {
            return;
        }
        if (this._currentDayEl) {
            this._replaceInAriaLabel(this._currentDayEl, 'Today');
        }
        this._appendToAriaLabel(ngbDpTodayEl, 'Today');
        this._currentDayEl = ngbDpTodayEl;
    }
    _appendToAriaLabel(element, text) {
        let ariaLabel = element.getAttribute('aria-label');
        if (!ariaLabel) {
            return;
        }
        if (!ariaLabel.match(/\.$/)) {
            ariaLabel += '.';
        }
        ariaLabel += ` ${text}.`;
        this._renderer2.setAttribute(element, 'aria-label', ariaLabel);
    }
    _replaceInAriaLabel(element, replace, replaceWith = '') {
        const ariaLabel = element.getAttribute('aria-label');
        if (!ariaLabel) {
            return;
        }
        const regExp = new RegExp(`\\s+${replace}\\.`);
        this._renderer2.setAttribute(element, 'aria-label', ariaLabel.replace(regExp, replaceWith));
    }
    onDateSelect(_selectedDate) {
        //this._checkA11y();
        this.dateSelect.emit(_selectedDate);
    }
    ngOnDestroy() {
        this._ngDestroy$.next();
        this._ngDestroy$.complete();
    }
    _announceNavigation(date) {
        const announcement = this._datePipe.transform(DateTimeModel.fromNgbDateStruct(date).toDate(), 'MMMM YYYY', undefined, this._datePickerService.getLocaleId());
        /* Added these lines since aria-hidden will be true whenever you open a modal.
          Inorder to announce previous and next months we need to remove aria-hidden.*/
        const ele = this._renderer.selectRootElement('.cdk-live-announcer-element');
        if (ele && ele.hasAttribute('aria-hidden')) {
            this._renderer.removeAttribute(ele, 'aria-hidden');
        }
        void this._liveAnnouncer.announce(announcement, 'polite');
    }
    /**
     * This method will add the aria-selected attribute to .ngb-dp-day and toggle it between true/false whenever a date is
     * selected either by clicking on the .ngb-dp-day element or by keydown.enter/keydown.space.
     *
     * It will also announce the selected date when done via keydown.enter/keydown.space which we found Jaws
     * 2023 was not doing.
     */
    _checkAriaSelectedAttributeForDaysInMonth() {
        this._elementRef.nativeElement.querySelectorAll('.ngb-dp-day').forEach((ngbDpDayEl) => {
            ngbDpDayEl.setAttribute('aria-selected', String(ngbDpDayEl.firstChild.classList.contains('selected')));
            fromEvent(ngbDpDayEl, 'mousedown')
                .pipe(takeUntil(this._ngDestroy$))
                .subscribe((event) => this._onNgbDpDayMouseDown(event));
            fromEvent(ngbDpDayEl, 'keydown')
                .pipe(takeUntil(this._ngDestroy$))
                .subscribe((event) => {
                this._onNgbDpDayKeyDown(event);
            });
        });
    }
    _onNgbDpDayMouseDown(event) {
        const targetEl = event?.target?.closest('.ngb-dp-day');
        if (!targetEl) {
            return;
        }
        if (this._hasSelectedNewDate(targetEl)) {
            this._setAsAriaSelected(targetEl);
        }
    }
    _onNgbDpDayKeyDown(event) {
        const keyboardEvent = event;
        if (!['Space', 'Enter'].includes(keyboardEvent.code)) {
            return;
        }
        const targetEl = event?.target?.closest('.ngb-dp-day');
        if (!targetEl) {
            return;
        }
        this._setAsAriaSelected(targetEl);
        // Jaws 2023 announces only 'Space' / 'Enter' instead of the full date being selected
        this._isStable.subscribe(() => this._announceSelectedDate());
    }
    /**
     * Our dayTemplate will add the 'selected' class to the first child of ngb-dp-day for selected elements; this way
     * we are able to know if the element was recently selected.
     * If it was already selected, then no updates have taken place, so there is no need to announce / toggle anything.
     *
     * @param targetEl .ngb-dp-day HTMLElement
     */
    _hasSelectedNewDate(ngbDpDayEl) {
        return !ngbDpDayEl.firstChild?.classList?.contains('selected');
    }
    _setAsAriaSelected(targetEl) {
        // Set aria-selected to false on the previously selected element
        this._elementRef.nativeElement
            .querySelector('.ngb-dp-day[aria-selected="true"]')
            ?.setAttribute('aria-selected', 'false');
        targetEl.setAttribute('aria-selected', 'true');
    }
    /**
     * Will announce the selected date with the following format: 'Tuesday, November 21, 2023, Selected'
     */
    _announceSelectedDate() {
        if (!this.ngbDatePickerCtrl.valid) {
            return;
        }
        const announcement = this._datePipe.transform(DateTimeModel.fromNgbDateStruct(this.ngbDatePickerCtrl.value).toDate(), 'EEEE, MMMM d, y', undefined, this._datePickerService.getLocaleId()) + ', Selected';
        void this._liveAnnouncer.announce(announcement, 'polite');
    }
    /**
     * Navigates to the requested month and ensures the focus date is correct (see note below)
     * @param date The new date to navigate to
     */
    _navigateToMonth(date) {
        this._suspendNgbDatepickerFocus(() => {
            this._ngbDatePicker.navigateTo(date);
            // if the newly-shown month is the same as the selected date (month and year), ensure that the focusDate is the
            // selectedDate. While odd to call focusDate() inside a _suspendNgbDatepickerFocus() callback, this is to ensure
            // the model is fully updated under the hood so that when the user tabs in, we get the expected behavior as
            // requested in https://mcgrawhill.atlassian.net/browse/OLAD-5567
            // Also note that it is done here rather than on focus of the ngb-datepicker-month to ensure that we proactively
            // control focus without interfering with user selection, i.e. if the user navigates to a new date in the same
            // month as the selected date, tabs out, and tabs back in, they expect to have the same new date (not the
            // selected date) focused.
            if (this._ngbDatePicker.model.selectedDate?.month === date.month &&
                this._ngbDatePicker.model.selectedDate?.year === date.year) {
                this._ngbDatePicker.focusDate(this._ngbDatePicker.model.selectedDate);
            }
            this._announceNavigation(date);
        });
    }
}
DatePickerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DatePickerComponent, deps: [{ token: i1.NgbDatepickerI18n }, { token: i0.ElementRef }, { token: i0.Renderer2 }, { token: DatePickerService }, { token: Injector }, { token: i2$1.LiveAnnouncer }, { token: i2.DatePipe }, { token: i0.Renderer2 }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
DatePickerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: DatePickerComponent, selector: "lh-datepicker", outputs: { dateSelect: "dateSelect" }, providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: DatePickerComponent,
            multi: true,
        },
    ], viewQueries: [{ propertyName: "_ngbDatePicker", first: true, predicate: NgbDatepicker, descendants: true }], ngImport: i0, template: "<ngb-datepicker\n  [displayMonths]=\"1\"\n  [dayTemplate]=\"dayTemplate\"\n  [startDate]=\"ngbDatePickerCtrl?.value\"\n  [formControl]=\"ngbDatePickerCtrl\"\n  (navigate)=\"onDatepickerNavigate($event)\"\n  navigation=\"none\"\n  [weekdays]=\"1\"\n  (focusin)=\"onNgbDatePickerFocusIn()\"\n  (dateSelect)=\"onDateSelect($event)\"\n>\n  <ng-template ngbDatepickerContent>\n    <div class=\"d-flex justify-content-between align-items-center border-bottom pb-2 mb-2\">\n      <button\n        type=\"button\"\n        class=\"btn btn-sm prev navigate-to-prev-month\"\n        (click)=\"navigateToPrevMonth()\"\n        aria-label=\"Previous Month\"\n        ngbTooltip=\"Previous Month\"\n      >\n        <i class=\"bi bi-chevron-left\"></i>\n      </button>\n      <div [attr.id]=\"uniqueId + '-months'\">\n        {{ i18n.getMonthFullName(navigatedTo.month) }} {{ navigatedTo.year }}\n      </div>\n      <button\n        type=\"button\"\n        class=\"btn btn-sm navigate-to-next-month\"\n        (click)=\"navigateToNextMonth()\"\n        aria-label=\"Next Month\"\n        ngbTooltip=\"Next Month\"\n      >\n        <i class=\"bi bi-chevron-right\"></i>\n      </button>\n    </div>\n    <ngb-datepicker-month [month]=\"navigatedTo\"></ngb-datepicker-month>\n  </ng-template>\n\n  <ng-template\n    #dayTemplate\n    let-date=\"date\"\n    let-currentMonth=\"currentMonth\"\n    let-selected=\"selected\"\n    let-disabled=\"disabled\"\n    let-today=\"today\"\n    let-focused=\"focused\"\n  >\n    <div\n      class=\"day\"\n      [class.text-body-secondary]=\"!selected && (date.month !== currentMonth || disabled)\"\n      [class.outside]=\"!selected && (date.month !== currentMonth || disabled)\"\n      [class.today]=\"today\"\n      [class.selected]=\"selected\"\n      [class.focused]=\"focused\"\n      [class.active]=\"\n        date.year === ngbDatePickerCtrl?.value?.year &&\n        date.month === ngbDatePickerCtrl?.value?.month &&\n        date.day === ngbDatePickerCtrl?.value?.day\n      \"\n    >\n      {{ date.day }}\n    </div>\n  </ng-template>\n</ngb-datepicker>\n", styles: [""], components: [{ type: i1.NgbDatepicker, selector: "ngb-datepicker", inputs: ["dayTemplate", "dayTemplateData", "displayMonths", "firstDayOfWeek", "footerTemplate", "markDisabled", "maxDate", "minDate", "navigation", "outsideDays", "showWeekNumbers", "startDate", "weekdays"], outputs: ["navigate", "dateSelect"], exportAs: ["ngbDatepicker"] }, { type: i1.NgbDatepickerMonth, selector: "ngb-datepicker-month", inputs: ["month"] }], directives: [{ type: i3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { type: i1.NgbDatepickerContent, selector: "ng-template[ngbDatepickerContent]" }, { type: i1.NgbTooltip, selector: "[ngbTooltip]", inputs: ["animation", "autoClose", "placement", "triggers", "container", "disableTooltip", "tooltipClass", "openDelay", "closeDelay", "ngbTooltip"], outputs: ["shown", "hidden"], exportAs: ["ngbTooltip"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DatePickerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lh-datepicker', providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: DatePickerComponent,
                            multi: true,
                        },
                    ], template: "<ngb-datepicker\n  [displayMonths]=\"1\"\n  [dayTemplate]=\"dayTemplate\"\n  [startDate]=\"ngbDatePickerCtrl?.value\"\n  [formControl]=\"ngbDatePickerCtrl\"\n  (navigate)=\"onDatepickerNavigate($event)\"\n  navigation=\"none\"\n  [weekdays]=\"1\"\n  (focusin)=\"onNgbDatePickerFocusIn()\"\n  (dateSelect)=\"onDateSelect($event)\"\n>\n  <ng-template ngbDatepickerContent>\n    <div class=\"d-flex justify-content-between align-items-center border-bottom pb-2 mb-2\">\n      <button\n        type=\"button\"\n        class=\"btn btn-sm prev navigate-to-prev-month\"\n        (click)=\"navigateToPrevMonth()\"\n        aria-label=\"Previous Month\"\n        ngbTooltip=\"Previous Month\"\n      >\n        <i class=\"bi bi-chevron-left\"></i>\n      </button>\n      <div [attr.id]=\"uniqueId + '-months'\">\n        {{ i18n.getMonthFullName(navigatedTo.month) }} {{ navigatedTo.year }}\n      </div>\n      <button\n        type=\"button\"\n        class=\"btn btn-sm navigate-to-next-month\"\n        (click)=\"navigateToNextMonth()\"\n        aria-label=\"Next Month\"\n        ngbTooltip=\"Next Month\"\n      >\n        <i class=\"bi bi-chevron-right\"></i>\n      </button>\n    </div>\n    <ngb-datepicker-month [month]=\"navigatedTo\"></ngb-datepicker-month>\n  </ng-template>\n\n  <ng-template\n    #dayTemplate\n    let-date=\"date\"\n    let-currentMonth=\"currentMonth\"\n    let-selected=\"selected\"\n    let-disabled=\"disabled\"\n    let-today=\"today\"\n    let-focused=\"focused\"\n  >\n    <div\n      class=\"day\"\n      [class.text-body-secondary]=\"!selected && (date.month !== currentMonth || disabled)\"\n      [class.outside]=\"!selected && (date.month !== currentMonth || disabled)\"\n      [class.today]=\"today\"\n      [class.selected]=\"selected\"\n      [class.focused]=\"focused\"\n      [class.active]=\"\n        date.year === ngbDatePickerCtrl?.value?.year &&\n        date.month === ngbDatePickerCtrl?.value?.month &&\n        date.day === ngbDatePickerCtrl?.value?.day\n      \"\n    >\n      {{ date.day }}\n    </div>\n  </ng-template>\n</ngb-datepicker>\n", styles: [""] }]
        }], ctorParameters: function () { return [{ type: i1.NgbDatepickerI18n }, { type: i0.ElementRef }, { type: i0.Renderer2 }, { type: DatePickerService }, { type: i0.Injector, decorators: [{
                    type: Inject,
                    args: [Injector]
                }] }, { type: i2$1.LiveAnnouncer }, { type: i2.DatePipe }, { type: i0.Renderer2 }, { type: i0.NgZone }]; }, propDecorators: { _ngbDatePicker: [{
                type: ViewChild,
                args: [NgbDatepicker]
            }], dateSelect: [{
                type: Output
            }] } });

class LhDatePickerModule {
}
LhDatePickerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: LhDatePickerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
LhDatePickerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: LhDatePickerModule, declarations: [DatePickerComponent], imports: [CommonModule, ReactiveFormsModule, NgbTooltipModule, NgbDatepickerModule], exports: [DatePickerComponent] });
LhDatePickerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: LhDatePickerModule, providers: [
        {
            provide: DatePipe,
            deps: [],
        },
        {
            provide: DatePickerService,
            deps: [DatePipe],
        },
    ], imports: [[CommonModule, ReactiveFormsModule, NgbTooltipModule, NgbDatepickerModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: LhDatePickerModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, ReactiveFormsModule, NgbTooltipModule, NgbDatepickerModule],
                    declarations: [DatePickerComponent],
                    exports: [DatePickerComponent],
                    providers: [
                        {
                            provide: DatePipe,
                            deps: [],
                        },
                        {
                            provide: DatePickerService,
                            deps: [DatePipe],
                        },
                    ],
                }]
        }] });

class TimePickerComponent {
    constructor(_datePipe, _datePickerService, _elementRef, _injector, _renderer2, _ngForm, _liveAnnouncer) {
        this._datePipe = _datePipe;
        this._datePickerService = _datePickerService;
        this._elementRef = _elementRef;
        this._injector = _injector;
        this._renderer2 = _renderer2;
        this._ngForm = _ngForm;
        this._liveAnnouncer = _liveAnnouncer;
        /**
         * error id to set aria-describedby
         *
         * @optional
         */
        this.timeErrorId = '';
        this._onTouched = noop;
        this._onChanged = noop;
        this._ngDestroy$ = new Subject();
        const today = new Date();
        const model = {
            minute: today.getMinutes(),
            hour: today.getHours(),
            second: today.getSeconds(),
        };
        this.ngbTimePickerCtrl = new FormControl(model, [
            Validators.required,
            this._datePickerService.timeValidator(),
        ]);
        this.ngbTimePickerCtrl.valueChanges.pipe(takeUntil(this._ngDestroy$)).subscribe((value) => {
            let hour = '';
            if (this.ngbTimePickerCtrl.invalid) {
                this._elementRef.nativeElement.querySelectorAll('input').forEach((el) => {
                    //Form value change sending null for hour/minute change and
                    //hence reading hour from (placeholder) input query
                    if (el.placeholder === 'HH') {
                        hour = el.value;
                    }
                    if (el.value == '') {
                        if (this.timeErrorId) {
                            this._renderer2.setAttribute(el, 'aria-describedby', this.timeErrorId);
                        }
                        this._renderer2.addClass(el, 'is-invalid');
                    }
                });
            }
            else {
                this._elementRef.nativeElement.querySelectorAll('input').forEach((el) => {
                    if (this.timeErrorId) {
                        this._renderer2.removeAttribute(el, 'aria-describedby');
                    }
                    this._renderer2.removeClass(el, 'is-invalid');
                });
            }
            /**
             * Check if the current time is in AM or PM and announce the change if it differs from the previous state
             * this functionality covers announcing the AM/PM change when switching between them
             */
            if (value) {
                const isPM = value && value.hour >= 12 ? 'PM' : 'AM';
                // Check if previousMeridiem is undefined to avoid announcing the AM/PM change when the modal first opens
                if (this.previousMeridiem !== undefined && this.previousMeridiem !== isPM) {
                    this.previousMeridiem = isPM;
                    /* Announcement is needed here because if there are manual changes to the input fields then subscription
                    will detect those changes and announce the message.
                    */
                    this.announceTimeChanged(value);
                }
                else if (this.previousMeridiem === undefined) {
                    this.previousMeridiem = isPM; // set the initial value of previousMeridiem
                }
            }
            else {
                // Live announcer is added for when the hour value is empty, and this is the behavior from the ngbtimepicker
                //where it gives null value when hour input is empty.
                //for reference: https://ng-bootstrap.github.io/#/components/timepicker/examples
                if (this.previousMeridiem === 'PM' && !hour) {
                    this.previousMeridiem = 'AM';
                    this.announceTimeChanged(value);
                }
            }
            this._onChanged(value);
        });
    }
    ngOnInit() {
        try {
            this._ngControl = this._injector.get(NgControl);
        }
        catch (e) {
            throw new Error('TimePicker expects an instance of NgControl injected; have you set formControlName / formControl in your template?');
        }
    }
    ngAfterViewInit() {
        const divElement = document.querySelector('.ngb-tp-meridian');
        const btnElement = divElement?.querySelector('.btn-outline-primary');
        if (btnElement) {
            btnElement.addEventListener('click', () => {
                if (this.ngbTimePickerCtrl.value === null) {
                    const minValue = document.querySelector('.ngb-tp-minute input');
                    const hourValue = document.querySelector('.ngb-tp-hour input');
                    const btnElementText = btnElement?.textContent !== null ? btnElement.textContent : '';
                    /**
                     * Announcement is needed here because if any of the minute or hour field is empty then the value is null.
                     * So if we click AM/PM button the value will always be null so the subscription event will not capture this.
                     */
                    this.announceTimeChanged({
                        hour: parseInt(hourValue.value),
                        minute: parseInt(minValue.value),
                        second: 0,
                    }, btnElementText);
                }
            });
        }
        this.setupA11y();
        if (this._ngForm) {
            const _ngForm = this._ngForm;
            _ngForm?.ngSubmit?.pipe(takeUntil(this._ngDestroy$)).subscribe(() => {
                this.ngbTimePickerCtrl.updateValueAndValidity();
            });
        }
    }
    setupA11y() {
        const timepickerHourEl = this._elementRef.nativeElement.querySelector('ngb-timepicker .ngb-tp-hour input');
        const timepickerMinEl = this._elementRef.nativeElement.querySelector('ngb-timepicker .ngb-tp-minute input');
        if (timepickerHourEl && timepickerMinEl) {
            timepickerHourEl.setAttribute('aria-required', 'true');
            timepickerMinEl.setAttribute('aria-required', 'true');
            timepickerHourEl.setAttribute('type', 'number');
            timepickerMinEl.setAttribute('type', 'number');
        }
    }
    writeValue(value) {
        this.ngbTimePickerCtrl.setValue(value);
    }
    registerOnChange(fn) {
        this._onChanged = fn;
    }
    registerOnTouched(fn) {
        this._onTouched = fn;
    }
    setDisabledState(isDisabled) {
        isDisabled ? this.ngbTimePickerCtrl.disable() : this.ngbTimePickerCtrl.enable();
    }
    /* istanbul ignore next */
    onFocusIn() {
        this._onTouched();
    }
    ngOnDestroy() {
        this._ngDestroy$.next();
        this._ngDestroy$.complete();
    }
    announceTimeChanged(message, meridiem) {
        /**
         * The 'aria-hidden' attribute is initially set to true when the modal opens.
         * Removed aria-hidden, to ensure that the change in the time announcement (AM/PM) is properly announced.
         */
        const cdkLiveAnnouncerElement = this._renderer2.selectRootElement('.cdk-live-announcer-element');
        if (cdkLiveAnnouncerElement && cdkLiveAnnouncerElement.hasAttribute('aria-hidden')) {
            this._renderer2.removeAttribute(cdkLiveAnnouncerElement, 'aria-hidden');
        }
        const announcementMessage = this._datePickerService.convertTimeFormatToAnnouncement(message, meridiem);
        //This duration is applied to ensure that the announcement is accessible and does not conflict with other inline error announcements.
        void this._liveAnnouncer.announce(`${announcementMessage}`, 'polite', 5000);
    }
}
TimePickerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: TimePickerComponent, deps: [{ token: i2.DatePipe }, { token: DatePickerService }, { token: i0.ElementRef }, { token: Injector }, { token: i0.Renderer2 }, { token: i3.ControlContainer, optional: true, skipSelf: true }, { token: i2$1.LiveAnnouncer }], target: i0.ɵɵFactoryTarget.Component });
TimePickerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: TimePickerComponent, selector: "lh-timepicker", inputs: { timeErrorId: "timeErrorId" }, providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: TimePickerComponent,
            multi: true,
        },
        DatePipe,
    ], viewQueries: [{ propertyName: "ngbTimepicker", first: true, predicate: NgbTimepicker, descendants: true }], ngImport: i0, template: "<ngb-timepicker\n  (focusin)=\"onFocusIn()\"\n  [formControl]=\"ngbTimePickerCtrl\"\n  [meridian]=\"true\"\n  [spinners]=\"false\"\n>\n</ngb-timepicker>\n", styles: [""], components: [{ type: i1.NgbTimepicker, selector: "ngb-timepicker", inputs: ["meridian", "spinners", "seconds", "hourStep", "minuteStep", "secondStep", "readonlyInputs", "size"] }], directives: [{ type: i3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: TimePickerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lh-timepicker', providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: TimePickerComponent,
                            multi: true,
                        },
                        DatePipe,
                    ], template: "<ngb-timepicker\n  (focusin)=\"onFocusIn()\"\n  [formControl]=\"ngbTimePickerCtrl\"\n  [meridian]=\"true\"\n  [spinners]=\"false\"\n>\n</ngb-timepicker>\n", styles: [""] }]
        }], ctorParameters: function () { return [{ type: i2.DatePipe }, { type: DatePickerService }, { type: i0.ElementRef }, { type: i0.Injector, decorators: [{
                    type: Inject,
                    args: [Injector]
                }] }, { type: i0.Renderer2 }, { type: i3.ControlContainer, decorators: [{
                    type: SkipSelf
                }, {
                    type: Optional
                }] }, { type: i2$1.LiveAnnouncer }]; }, propDecorators: { timeErrorId: [{
                type: Input
            }], ngbTimepicker: [{
                type: ViewChild,
                args: [NgbTimepicker]
            }] } });

class DateTimePickerComponent {
    constructor(_elementRef, _renderer, _dom, _datePickerService, _injector, _ngZone, _configurableFocusTrapFactory, _liveAnnouncer, _datePipe, _interactivityChecker) {
        this._elementRef = _elementRef;
        this._renderer = _renderer;
        this._dom = _dom;
        this._datePickerService = _datePickerService;
        this._injector = _injector;
        this._ngZone = _ngZone;
        this._configurableFocusTrapFactory = _configurableFocusTrapFactory;
        this._liveAnnouncer = _liveAnnouncer;
        this._datePipe = _datePipe;
        this._interactivityChecker = _interactivityChecker;
        /**
         * Used as a title for the popover
         *
         * @optional
         */
        this.heading = 'Edit Date';
        /**
         * Tooltip for the button which shows/hides the popover
         *
         * @optional
         */
        this.tooltipText = 'Edit Date';
        /**
         * Whether to show a time picker
         *
         * @optional
         */
        this.hasTime = true;
        /**
         * Preferred placement for the popover
         */
        this.placement = 'bottom-end auto';
        /**
         * NgbPopover container, supports only the 'body' element as custom value.
         *
         * Ng-bootstrap's popover only supports the 'body' element to be passed as custom value, otherwise it will select
         * the element to append ngb-popover-window itself, that is, when container is undefined. To avoid using
         * [container]="undefined" and leave the default value being 'body', we created the 'auto' type.
         *
         * @see https://github.com/ng-bootstrap/ng-bootstrap/blob/12.1.2/src/popover/popover.ts#L127
         */
        this.container = 'body';
        /**
         * aria-label for the button which shows/hides the popover
         * Must be unique on the page
         * @optional
         */
        this.ariaLabel = '';
        /**
         * aria-describedby for the button which shows/hides the popover
         * to associate any additional information, if any
         * Must be unique on the page
         * @optional
         */
        this.ariaDescribedby = '';
        /**
         * Triggers when date/time picker is about to show
         */
        this.shows = new EventEmitter();
        /**
         * Triggers when date/time picker is about to start hiding itself
         */
        this.hides = new EventEmitter();
        /**
         * Triggers when date/time picker finished opening
         */
        this.shown = new EventEmitter();
        /**
         * Triggers when date/time picker is hidden, ngb-popover-window should no longer exist on the dom
         */
        this.hidden = new EventEmitter();
        this.isDisabled = false;
        this.description = 'Select a date and use the Apply button to update';
        this._ngDestroy$ = new Subject();
        this._onTouched = noop;
        this._onChanged = noop;
        this._popoverWindowEl = null;
        this._configurableFocusTrap = null;
        this._DATE_TIME_PICKER_CONTENT_SELECTOR = '.datetime-picker-popover-content';
        this._isDateTimePickerOpen = false;
        this._shouldRestoreFocus = true;
        this._tooltipClosed = false;
        this.idBase = `datetime-${this._datePickerService.generateUniqueId()}`;
        const today = new Date();
        const dateModel = {
            year: today.getFullYear(),
            month: today.getMonth() + 1,
            day: today.getDate(),
        };
        const timeModel = {
            hour: today.getHours(),
            minute: today.getMinutes(),
            second: today.getSeconds(),
        };
        this.datePickerCtrl = new FormControl(dateModel, [
            Validators.required,
            this._datePickerService.dateTimeValidator(),
        ]);
        this.timePickerCtrl = new FormControl(timeModel, [
            Validators.required,
            this._datePickerService.timeValidator(),
        ]);
        this.formGroup = new FormGroup({
            date: this.datePickerCtrl,
            time: this.timePickerCtrl,
        });
    }
    ngOnInit() {
        try {
            this.ngControl = this._injector.get(NgControl);
        }
        catch (e) {
            throw new Error('DatetimePicker expects an instance of NgControl injected; have you set formControlName / formControl on the datetime picker component within your template?');
        }
        if (this.hasTime) {
            this.description = 'Select a date and time, and then use the Apply button to update';
        }
    }
    ngAfterViewInit() {
        this.addEscapeKeyListener();
        this.ngbPopover.shown.pipe(takeUntil(this._ngDestroy$)).subscribe(() => {
            this._previousDateTimeModel = this._getDateTimeModel();
            this._shouldRestoreFocus = true;
            this._onTouched();
            this._setupDateTimePicker();
            this._isDateTimePickerOpen = true;
            this.shown.emit();
        });
        this.ngbPopover.hidden.pipe(takeUntil(this._ngDestroy$)).subscribe(() => {
            this._destroyFocusTrap();
            if (this._shouldRestoreFocus) {
                this._restoreFocus();
            }
            this._isDateTimePickerOpen = false;
            this.hidden.emit();
        });
        this.ngbTooltip?.shown.pipe(takeUntil(this._ngDestroy$)).subscribe(() => {
            if (this.ariaDescribedby) {
                // Timer needed to let tooltip be announced and then the extra information
                timer(100).subscribe(() => {
                    this.dtpBtn.nativeElement.setAttribute('aria-describedby', this.ariaDescribedby);
                });
            }
        });
    }
    _setupDateTimePicker() {
        this._popoverWindowEl = this._dom.querySelector(`.${this.idBase}-edit`);
        this._setupA11y();
        this._ngZone.runOutsideAngular(() => {
            const closing$ = new Subject();
            const shouldCloseOnClick = (event) => {
                if (!event.target) {
                    return {
                        willClosePopover: false,
                        event,
                    };
                }
                const targetEl = event.target;
                const willClosePopover = !this._popoverWindowEl?.contains(targetEl);
                return {
                    willClosePopover,
                    event,
                };
            };
            fromEvent(this._dom, 'mousedown')
                .pipe(map(shouldCloseOnClick), takeUntil(closing$))
                .subscribe((result) => {
                if (!result.willClosePopover) {
                    return;
                }
                const targetEl = result.event.target;
                if (this._interactivityChecker.isFocusable(targetEl)) {
                    this._shouldRestoreFocus = false;
                }
                this.hides.emit();
                this._destroyFocusTrap();
                this.ngbPopover.close();
                closing$.next();
                closing$.complete();
            });
        });
    }
    addEscapeKeyListener() {
        this._renderer.listen('document', 'keydown.escape', (event) => {
            if (event.key === 'Escape') {
                if (!this._isDateTimePickerOpen) {
                    return;
                }
                const target = event.target;
                if (target.hasAttribute('ngbtooltip') && !this._tooltipClosed) {
                    this._tooltipClosed = true;
                }
                else {
                    this._tooltipClosed = false;
                    this.onCancel();
                }
            }
        });
    }
    apply() {
        if (this.formGroup.invalid) {
            return;
        }
        this._onChanged(this._getDateTimeModel());
        this._announceDateChange();
        this.ngbPopover.close();
    }
    _announceDateChange() {
        let announcement = `Date`;
        if (this.hasTime) {
            announcement += ' and time';
        }
        announcement += ' updated to: ';
        const dateTimeModel = this._getDateTimeModel();
        let dateFormat = 'EEEE, MMMM d yyyy';
        if (this.hasTime) {
            dateFormat += ' h:m a';
        }
        const formattedDate = this._datePipe.transform(dateTimeModel.toDate(), dateFormat, undefined, this._datePickerService.getLocaleId());
        announcement += formattedDate;
        this._announce(announcement);
    }
    _announce(announcement, politeness = 'polite') {
        void this._liveAnnouncer.announce(announcement, politeness);
    }
    _getDateTimeModel() {
        const newModel = DateTimeModel.fromDateModel(this.datePickerCtrl.value);
        if (this.hasTime) {
            const timeModel = this.timePickerCtrl.value;
            newModel.hour = timeModel.hour;
            newModel.minute = timeModel.minute;
            newModel.second = timeModel.second;
        }
        return newModel;
    }
    onCancel() {
        this.hides.emit();
        // Run later to allow the popover to close right away
        setTimeout(() => {
            this._restorePreviousDate();
        }, 500);
        this._announce('No updates applied.');
        this.ngbPopover.close();
    }
    _restorePreviousDate() {
        if (!this._datePickerService.isValidDateTime(this._previousDateTimeModel)) {
            return;
        }
        const _previousDateTimeModel = this._previousDateTimeModel;
        this.datePickerCtrl.setValue({
            year: _previousDateTimeModel.year,
            month: _previousDateTimeModel.month,
            day: _previousDateTimeModel.day,
        });
        if (this._datePickerService.isValidTime(_previousDateTimeModel)) {
            this.timePickerCtrl.setValue({
                hour: _previousDateTimeModel.hour,
                minute: _previousDateTimeModel.minute,
                second: _previousDateTimeModel.second,
            });
        }
    }
    _setupA11y() {
        if (!this._popoverWindowEl) {
            return;
        }
        this._popoverWindowEl.querySelector('button.btn-close')?.focus();
        this._popoverWindowEl.setAttribute('role', 'dialog');
        this._popoverWindowEl.setAttribute('aria-modal', 'true');
        this._popoverWindowEl.setAttribute('aria-labelledby', `${this.idBase}-heading`);
    }
    writeValue(value) {
        if (!(value instanceof DateTimeModel)) {
            throw new Error('Datetime picker expects an instance of DateTimeModel');
        }
        this.datePickerCtrl.setValue({
            year: value.year,
            month: value.month,
            day: value.day,
        });
        this.timePickerCtrl.setValue({
            hour: value.hour,
            minute: value.minute,
            second: value.second,
        });
    }
    registerOnChange(fn) {
        this._onChanged = fn;
    }
    registerOnTouched(fn) {
        this._onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.isDisabled = isDisabled;
    }
    _restoreFocus() {
        this._elementRef.nativeElement.querySelector('.open-datepicker-btn')?.focus();
    }
    onPopoverFocusIn($event, dateTimePickerEl) {
        if (this._configurableFocusTrap) {
            return;
        }
        this._configurableFocusTrap = this._configurableFocusTrapFactory.create(dateTimePickerEl);
    }
    _destroyFocusTrap() {
        this._configurableFocusTrap?.destroy();
        this._configurableFocusTrap = null;
    }
    closeTooltipOnEsc(tooltip) {
        if (tooltip.isOpen()) {
            tooltip.close();
        }
    }
    /**
     * Call when the date/time picker is about to toggle; i.e. if it was showing it will become hidden.
     */
    toggles() {
        this._isDateTimePickerOpen ? this.hides.emit() : this.shows.emit();
    }
    ngOnDestroy() {
        this._ngDestroy$.next();
        this._ngDestroy$.complete();
    }
}
DateTimePickerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DateTimePickerComponent, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: DOCUMENT }, { token: DatePickerService }, { token: Injector }, { token: i0.NgZone }, { token: i2$1.ConfigurableFocusTrapFactory }, { token: i2$1.LiveAnnouncer }, { token: i2.DatePipe }, { token: i2$1.InteractivityChecker }], target: i0.ɵɵFactoryTarget.Component });
DateTimePickerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: DateTimePickerComponent, selector: "lh-datetime-picker", inputs: { heading: "heading", tooltipText: "tooltipText", hasTime: "hasTime", placement: "placement", container: "container", ariaLabel: "ariaLabel", ariaDescribedby: "ariaDescribedby" }, outputs: { shows: "shows", hides: "hides", shown: "shown", hidden: "hidden" }, providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: DateTimePickerComponent,
            multi: true,
        },
        {
            provide: NgControl,
            useExisting: FormControlName,
            multi: true,
        },
        {
            provide: NgControl,
            useExisting: FormControlDirective,
            multi: true,
        },
    ], viewQueries: [{ propertyName: "ngbPopover", first: true, predicate: ["ngbPopoverRef"], descendants: true }, { propertyName: "ngbTooltip", first: true, predicate: ["ngbTooltipRef"], descendants: true }, { propertyName: "dtpBtn", first: true, predicate: ["dtpBtn"], descendants: true }], ngImport: i0, template: "<div *ngIf=\"ngControl\">\n  <button\n    class=\"btn btn-outline-primary open-datepicker-btn\"\n    type=\"button\"\n    [ngbPopover]=\"dateTimeContent\"\n    [autoClose]=\"false\"\n    [attr.id]=\"idBase + '-edit'\"\n    [popoverClass]=\"idBase + '-edit'\"\n    #ngbPopoverRef=\"ngbPopover\"\n    [placement]=\"placement\"\n    [attr.aria-label]=\"ariaLabel ? ariaLabel : heading\"\n    [attr.tabindex]=\"isDisabled ? '-1' : null\"\n    [ngbTooltip]=\"tooltipText\"\n    #ngbTooltipRef=\"ngbTooltip\"\n    [disableTooltip]=\"isDisabled\"\n    [disablePopover]=\"isDisabled\"\n    [ngClass]=\"{ disabled: isDisabled }\"\n    [container]=\"container\"\n    (click)=\"toggles()\"\n    (keydown.enter)=\"toggles()\"\n    (keydown.space)=\"toggles()\"\n    (keyup.escape)=\"closeTooltipOnEsc(ngbTooltipRef)\"\n    #dtpBtn\n  >\n    <i class=\"bi bi-calendar-week\"></i>\n  </button>\n\n  <ng-template #dateTimeContent>\n    <form\n      [formGroup]=\"formGroup\"\n      (ngSubmit)=\"apply()\"\n      #ngForm=\"ngForm\"\n      class=\"datetime-picker-popover-content\"\n    >\n      <div (focusin)=\"onPopoverFocusIn($event, dateTimePickerRef)\" #dateTimePickerRef>\n        <div class=\"d-flex justify-content-between border-bottom mb-3 pb-3 header-text\">\n          <h2 class=\"fs-6 m-0\" [attr.id]=\"idBase + '-heading'\">\n            {{ heading }}\n          </h2>\n          <button\n            type=\"button\"\n            [attr.id]=\"idBase + '-close'\"\n            class=\"btn-close\"\n            aria-label=\"Close\"\n            (click)=\"onCancel()\"\n          ></button>\n        </div>\n\n        <p aria-hidden=\"true\"><span class=\"required\">*</span> Required</p>\n        <p [attr.id]=\"idBase + '-description'\">{{ description }}</p>\n\n        <div class=\"mb-3\">\n          <h3 class=\"fs-6\">\n            Date <span class=\"required\" aria-hidden=\"true\">*</span>\n            <span class=\"visually-hidden\"> is required</span>\n          </h3>\n          <lh-datepicker [formControl]=\"datePickerCtrl\"></lh-datepicker>\n        </div>\n        <div class=\"required\" *ngIf=\"ngForm.submitted && ngForm.invalid && datePickerCtrl.invalid\">\n          * Date is required\n        </div>\n\n        <div *ngIf=\"hasTime\" class=\"mb-3\">\n          <h3 class=\"fs-6\">\n            Time <span class=\"required\" aria-hidden=\"true\">*</span>\n            <span class=\"visually-hidden\"> is required</span>\n          </h3>\n          <lh-timepicker [formControl]=\"timePickerCtrl\" timeErrorId=\"timeRequired\"></lh-timepicker>\n        </div>\n        <div>\n          <div id=\"timeRequired\" class=\"invalid-feedback\" *ngIf=\"ngForm.invalid && timePickerCtrl.invalid\">\n            Time is required\n          </div>\n        </div>\n\n        <div class=\"d-flex gap-2 border-top pt-3\">\n          <button type=\"button\" class=\"btn btn-outline-primary btn-cancel\" (click)=\"onCancel()\">\n            Cancel\n          </button>\n          <button type=\"submit\" class=\"btn btn-primary\">Apply</button>\n        </div>\n      </div>\n    </form>\n  </ng-template>\n</div>\n", styles: [".open-datepicker-btn{border-radius:0 8px 8px 0/0px 8px 8px 0px!important;border-left:none!important}.required{color:var(--bs-danger)}.invalid-feedback{font-size:14px;display:block}\n"], components: [{ type: DatePickerComponent, selector: "lh-datepicker", outputs: ["dateSelect"] }, { type: TimePickerComponent, selector: "lh-timepicker", inputs: ["timeErrorId"] }], directives: [{ type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i1.NgbPopover, selector: "[ngbPopover]", inputs: ["animation", "autoClose", "ngbPopover", "popoverTitle", "placement", "triggers", "container", "disablePopover", "popoverClass", "openDelay", "closeDelay"], outputs: ["shown", "hidden"], exportAs: ["ngbPopover"] }, { type: i1.NgbTooltip, selector: "[ngbTooltip]", inputs: ["animation", "autoClose", "placement", "triggers", "container", "disableTooltip", "tooltipClass", "openDelay", "closeDelay", "ngbTooltip"], outputs: ["shown", "hidden"], exportAs: ["ngbTooltip"] }, { type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i3.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i3.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i3.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DateTimePickerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lh-datetime-picker', providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: DateTimePickerComponent,
                            multi: true,
                        },
                        {
                            provide: NgControl,
                            useExisting: FormControlName,
                            multi: true,
                        },
                        {
                            provide: NgControl,
                            useExisting: FormControlDirective,
                            multi: true,
                        },
                    ], template: "<div *ngIf=\"ngControl\">\n  <button\n    class=\"btn btn-outline-primary open-datepicker-btn\"\n    type=\"button\"\n    [ngbPopover]=\"dateTimeContent\"\n    [autoClose]=\"false\"\n    [attr.id]=\"idBase + '-edit'\"\n    [popoverClass]=\"idBase + '-edit'\"\n    #ngbPopoverRef=\"ngbPopover\"\n    [placement]=\"placement\"\n    [attr.aria-label]=\"ariaLabel ? ariaLabel : heading\"\n    [attr.tabindex]=\"isDisabled ? '-1' : null\"\n    [ngbTooltip]=\"tooltipText\"\n    #ngbTooltipRef=\"ngbTooltip\"\n    [disableTooltip]=\"isDisabled\"\n    [disablePopover]=\"isDisabled\"\n    [ngClass]=\"{ disabled: isDisabled }\"\n    [container]=\"container\"\n    (click)=\"toggles()\"\n    (keydown.enter)=\"toggles()\"\n    (keydown.space)=\"toggles()\"\n    (keyup.escape)=\"closeTooltipOnEsc(ngbTooltipRef)\"\n    #dtpBtn\n  >\n    <i class=\"bi bi-calendar-week\"></i>\n  </button>\n\n  <ng-template #dateTimeContent>\n    <form\n      [formGroup]=\"formGroup\"\n      (ngSubmit)=\"apply()\"\n      #ngForm=\"ngForm\"\n      class=\"datetime-picker-popover-content\"\n    >\n      <div (focusin)=\"onPopoverFocusIn($event, dateTimePickerRef)\" #dateTimePickerRef>\n        <div class=\"d-flex justify-content-between border-bottom mb-3 pb-3 header-text\">\n          <h2 class=\"fs-6 m-0\" [attr.id]=\"idBase + '-heading'\">\n            {{ heading }}\n          </h2>\n          <button\n            type=\"button\"\n            [attr.id]=\"idBase + '-close'\"\n            class=\"btn-close\"\n            aria-label=\"Close\"\n            (click)=\"onCancel()\"\n          ></button>\n        </div>\n\n        <p aria-hidden=\"true\"><span class=\"required\">*</span> Required</p>\n        <p [attr.id]=\"idBase + '-description'\">{{ description }}</p>\n\n        <div class=\"mb-3\">\n          <h3 class=\"fs-6\">\n            Date <span class=\"required\" aria-hidden=\"true\">*</span>\n            <span class=\"visually-hidden\"> is required</span>\n          </h3>\n          <lh-datepicker [formControl]=\"datePickerCtrl\"></lh-datepicker>\n        </div>\n        <div class=\"required\" *ngIf=\"ngForm.submitted && ngForm.invalid && datePickerCtrl.invalid\">\n          * Date is required\n        </div>\n\n        <div *ngIf=\"hasTime\" class=\"mb-3\">\n          <h3 class=\"fs-6\">\n            Time <span class=\"required\" aria-hidden=\"true\">*</span>\n            <span class=\"visually-hidden\"> is required</span>\n          </h3>\n          <lh-timepicker [formControl]=\"timePickerCtrl\" timeErrorId=\"timeRequired\"></lh-timepicker>\n        </div>\n        <div>\n          <div id=\"timeRequired\" class=\"invalid-feedback\" *ngIf=\"ngForm.invalid && timePickerCtrl.invalid\">\n            Time is required\n          </div>\n        </div>\n\n        <div class=\"d-flex gap-2 border-top pt-3\">\n          <button type=\"button\" class=\"btn btn-outline-primary btn-cancel\" (click)=\"onCancel()\">\n            Cancel\n          </button>\n          <button type=\"submit\" class=\"btn btn-primary\">Apply</button>\n        </div>\n      </div>\n    </form>\n  </ng-template>\n</div>\n", styles: [".open-datepicker-btn{border-radius:0 8px 8px 0/0px 8px 8px 0px!important;border-left:none!important}.required{color:var(--bs-danger)}.invalid-feedback{font-size:14px;display:block}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: Document, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: DatePickerService }, { type: i0.Injector, decorators: [{
                    type: Inject,
                    args: [Injector]
                }] }, { type: i0.NgZone }, { type: i2$1.ConfigurableFocusTrapFactory }, { type: i2$1.LiveAnnouncer }, { type: i2.DatePipe }, { type: i2$1.InteractivityChecker }]; }, propDecorators: { heading: [{
                type: Input
            }], tooltipText: [{
                type: Input
            }], hasTime: [{
                type: Input
            }], placement: [{
                type: Input
            }], container: [{
                type: Input
            }], ariaLabel: [{
                type: Input
            }], ariaDescribedby: [{
                type: Input
            }], shows: [{
                type: Output
            }], hides: [{
                type: Output
            }], shown: [{
                type: Output
            }], hidden: [{
                type: Output
            }], ngbPopover: [{
                type: ViewChild,
                args: ['ngbPopoverRef']
            }], ngbTooltip: [{
                type: ViewChild,
                args: ['ngbTooltipRef']
            }], dtpBtn: [{
                type: ViewChild,
                args: ['dtpBtn']
            }] } });

class LhTimePickerModule {
}
LhTimePickerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: LhTimePickerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
LhTimePickerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: LhTimePickerModule, declarations: [TimePickerComponent], imports: [CommonModule, ReactiveFormsModule, NgbTimepickerModule], exports: [TimePickerComponent] });
LhTimePickerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: LhTimePickerModule, providers: [
        {
            provide: DatePipe,
            deps: [],
        },
        {
            provide: DatePickerService,
            deps: [DatePipe],
        },
    ], imports: [[CommonModule, ReactiveFormsModule, NgbTimepickerModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: LhTimePickerModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, ReactiveFormsModule, NgbTimepickerModule],
                    declarations: [TimePickerComponent],
                    exports: [TimePickerComponent],
                    providers: [
                        {
                            provide: DatePipe,
                            deps: [],
                        },
                        {
                            provide: DatePickerService,
                            deps: [DatePipe],
                        },
                    ],
                }]
        }] });

class LhDateTimePickerModule {
}
LhDateTimePickerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: LhDateTimePickerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
LhDateTimePickerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: LhDateTimePickerModule, declarations: [DateTimePickerComponent], imports: [CommonModule,
        NgbPopoverModule,
        NgbTooltipModule,
        FormsModule,
        ReactiveFormsModule,
        A11yModule,
        LhDatePickerModule,
        LhTimePickerModule], exports: [DateTimePickerComponent] });
LhDateTimePickerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: LhDateTimePickerModule, providers: [
        ConfigurableFocusTrapFactory,
        {
            provide: DatePipe,
            deps: [],
        },
        {
            provide: DatePickerService,
            deps: [DatePipe],
        },
    ], imports: [[
            CommonModule,
            NgbPopoverModule,
            NgbTooltipModule,
            FormsModule,
            ReactiveFormsModule,
            A11yModule,
            LhDatePickerModule,
            LhTimePickerModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: LhDateTimePickerModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        NgbPopoverModule,
                        NgbTooltipModule,
                        FormsModule,
                        ReactiveFormsModule,
                        A11yModule,
                        LhDatePickerModule,
                        LhTimePickerModule,
                    ],
                    declarations: [DateTimePickerComponent],
                    exports: [DateTimePickerComponent],
                    providers: [
                        ConfigurableFocusTrapFactory,
                        {
                            provide: DatePipe,
                            deps: [],
                        },
                        {
                            provide: DatePickerService,
                            deps: [DatePipe],
                        },
                    ],
                }]
        }] });

/**
 * Wrapper for the ng-bootstrap Modal Service, specifically for its open function.
 * Ng-bootstrap adds an unnecessary role of "document" to the container within the
 * modal. We cannot remove the document role via a directive or other means as the
 * modal is created programmatically within the ng-boostrap modal service.
 *
 * For other methods on the service, the NgbModal service should be used directly.
 *
 * Could not extend the NgbModal service, as one of its constructor arguments is not
 * exported by ng-bootstrap.
 */
class OlNgbA11yModalService {
    constructor(_dom, _rendererFactory, _modalService) {
        this._dom = _dom;
        this._rendererFactory = _rendererFactory;
        this._modalService = _modalService;
        this._renderer = this._rendererFactory.createRenderer(null, null);
    }
    /**
     * Calls the modal service's "open" method, then immediately modifies the DOM
     * to remove the "document" role from the modal. Note that this will also
     * remove the "document" role on any other ng-bootstrap modal's modal-dialog
     * container currently open, however only one should be open at a time, and
     * there is no use case we've determined for the role to be on that container.
     */
    open(content, options = {}, lhOptions) {
        const modalRef = this._modalService.open(content, options);
        const modalDialogEl = this._dom.querySelector('ngb-modal-window div[role="document"].modal-dialog');
        this._renderer.removeAttribute(modalDialogEl, 'role');
        if (lhOptions?.unhideLiveAnnouncer) {
            const liveAnnouncerEl = this._dom.querySelector('.cdk-live-announcer-element');
            this._renderer.setAttribute(liveAnnouncerEl, 'aria-hidden', 'false');
        }
        return modalRef;
    }
}
OlNgbA11yModalService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: OlNgbA11yModalService, deps: [{ token: DOCUMENT }, { token: i0.RendererFactory2 }, { token: i1.NgbModal }], target: i0.ɵɵFactoryTarget.Injectable });
OlNgbA11yModalService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: OlNgbA11yModalService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: OlNgbA11yModalService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: Document, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: i0.RendererFactory2 }, { type: i1.NgbModal }]; } });

/**
 * Generated bundle index. Do not edit.
 */

export { CharactersRemainingDirective, DatePickerComponent, DatePickerService, DateTimeModel, DateTimePickerComponent, LhDatePickerModule, LhDateTimePickerModule, LhDropMenuComponent, LhDropMenuModule, LhKeyboardInstructionsPopoverComponent, LhKeyboardInstructionsPopoverModule, LhMultiSelectModule, LhSpinnerComponent, LhSpinnerModule, LhTimePickerModule, LhToastModule, MultiSelectComponent, NavigationRouterOutletDirective, NavigationTabIndexDirective, NgbA11yDropMenuDirective, NgbA11yDropSelectDirective, NgbA11yDropdownModule, NgbA11yDropselectModule, NgbA11yRouterOutletNavModule, NgbA11yTabIndexModule, NgbDropdownToggleNoCaretDirective, OlGridWidgetDirective, OlNgbA11yModalService, OlNgbA11yPaginationDirective, OlNgbA11yPaginationModule, OlNgbA11yPopoverDirective, OlNgbA11yPopoverModule, OlNgbA11ySortableDataGridDirective, OlNgbA11ySortableDataGridModule, OlNgbA11ySortableHeaderDirective, OlNgbA11ySortableTableDirective, OlNgbA11ySortableTableModule, OlNgbCharactersRemainingModule, OptionBehavior, SearchBarComponent, SearchInputModule, SelectAutomationIdPipe, TimePickerComponent, ToastComponent, ToastService };
